import { cacheExchange } from '@urql/exchange-graphcache';
import type { Resolver as GraphCacheResolver, UpdateResolver as GraphCacheUpdateResolver, OptimisticMutationResolver as GraphCacheOptimisticMutationResolver } from '@urql/exchange-graphcache';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** A valid locale code (en, es, ca, de, fr, it, pt) */
  Locale: { input: any; output: any; }
};

export type BaseError = Error & {
  __typename?: 'BaseError';
  message: Scalars['String']['output'];
};

export type CancelStripeSetupResult = {
  __typename?: 'CancelStripeSetupResult';
  publication: Publication;
};

export type CancelSubscriptionResult = {
  __typename?: 'CancelSubscriptionResult';
  message: Scalars['String']['output'];
  subscription: Sub;
  success: Scalars['Boolean']['output'];
};

export type ContentAccess = {
  __typename?: 'ContentAccess';
  hasAccess: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  requiredTiers: Array<SubscriptionTier>;
  restricted: Scalars['Boolean']['output'];
};

export type CustomerPortalSessionResult = {
  __typename?: 'CustomerPortalSessionResult';
  url: Scalars['String']['output'];
};

export type Error = {
  message: Scalars['String']['output'];
};

export type FeeLevelEntry = {
  __typename?: 'FeeLevelEntry';
  feePercent: Scalars['Int']['output'];
  threshold: Scalars['Int']['output'];
};

export type FlaggedMessageError = Error & {
  __typename?: 'FlaggedMessageError';
  message: Scalars['String']['output'];
};

export type GroupedReaction = {
  __typename?: 'GroupedReaction';
  emojis: Array<Scalars['String']['output']>;
  latestReactionAt: Scalars['DateTime']['output'];
  latestReactorProfileImage?: Maybe<Scalars['String']['output']>;
  otherCount: Scalars['Int']['output'];
  postId: Scalars['String']['output'];
  postTitle: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
  userNames: Array<Scalars['String']['output']>;
};

export type LeadMagnetFile = {
  __typename?: 'LeadMagnetFile';
  createdAt: Scalars['DateTime']['output'];
  formId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  src: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LeadMagnetForm = {
  __typename?: 'LeadMagnetForm';
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emailBody?: Maybe<Scalars['String']['output']>;
  emailSubject: Scalars['String']['output'];
  files: Array<LeadMagnetFile>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  private: Scalars['Boolean']['output'];
  subscribersCount: Scalars['Int']['output'];
  tier?: Maybe<SubscriptionTier>;
  tierId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeadMagnetFormFileInput = {
  src: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type Me = UserInterface & {
  __typename?: 'Me';
  authorName?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentOnboardingTask?: Maybe<OnboardingTask>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  interestCategories?: Maybe<Scalars['String']['output']>;
  interfaceLocale: Scalars['Locale']['output'];
  isAdmin: Scalars['Boolean']['output'];
  onboardingStage?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  publication?: Maybe<Publication>;
  readerOnboarded: Scalars['Boolean']['output'];
  signupSource?: Maybe<Scalars['String']['output']>;
  socialBandcamp?: Maybe<Scalars['String']['output']>;
  socialBluesky?: Maybe<Scalars['String']['output']>;
  socialBooks?: Maybe<Scalars['String']['output']>;
  socialFacebook?: Maybe<Scalars['String']['output']>;
  socialInstagram?: Maybe<Scalars['String']['output']>;
  socialLinkedin?: Maybe<Scalars['String']['output']>;
  socialSoundcloud?: Maybe<Scalars['String']['output']>;
  socialTiktok?: Maybe<Scalars['String']['output']>;
  socialWebsite?: Maybe<Scalars['String']['output']>;
  socialX?: Maybe<Scalars['String']['output']>;
  socialYoutube?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
  weeklyFeaturedPostsUnsubscribed: Scalars['Boolean']['output'];
};

export type Message = {
  __typename?: 'Message';
  author: User;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
};

export enum MessageFormat {
  Markdown = 'markdown',
  Tiptap = 'tiptap'
}

export type Mutation = {
  __typename?: 'Mutation';
  archivePost: MutationArchivePostResult;
  cancelStripeSetup: MutationCancelStripeSetupResult;
  cancelSubscription: MutationCancelSubscriptionResult;
  changePostMainLocale: MutationChangePostMainLocaleResult;
  claimLeadMagnetForm: MutationClaimLeadMagnetFormResult;
  createCustomerPortalSession: MutationCreateCustomerPortalSessionResult;
  createNote: MutationCreateNoteResult;
  createPost: MutationCreatePostResult;
  createPublicationExport: MutationCreatePublicationExportResult;
  deleteCurrentUser: MutationDeleteCurrentUserResult;
  deleteLeadMagnetForm: MutationDeleteLeadMagnetFormResult;
  deleteMessage: MutationDeleteMessageResult;
  deleteNote: MutationDeleteNoteResult;
  deletePost: MutationDeletePostResult;
  generateTranslation: MutationGenerateTranslationResult;
  markThreadRead: Scalars['Boolean']['output'];
  markTranslationAsUpdated: MutationMarkTranslationAsUpdatedResult;
  proofread: MutationProofreadResult;
  publishPost: MutationPublishPostResult;
  restorePostVersion: MutationRestorePostVersionResult;
  savePost: MutationSavePostResult;
  sendMessage: MutationSendMessageResult;
  sendTestPostEmail: MutationSendTestPostEmailResult;
  setTags: MutationSetTagsResult;
  setTranslations: MutationSetTranslationsResult;
  setUserBanned: MutationSetUserBannedResult;
  skipOnboardingTask: MutationSkipOnboardingTaskResult;
  subscribeTo: MutationSubscribeToResult;
  toggleReaction: PublishedPost;
  translateFields: MutationTranslateFieldsResult;
  translateMessage: MutationTranslateMessageResult;
  unlinkStripeAccount: MutationUnlinkStripeAccountResult;
  unsubscribeFrom: MutationUnsubscribeFromResult;
  updateCurrentPublication: MutationUpdateCurrentPublicationResult;
  updateCurrentUser: MutationUpdateCurrentUserResult;
  updateNote: MutationUpdateNoteResult;
  updateOptOutFeaturedPosts: MutationUpdateOptOutFeaturedPostsResult;
  updatePostSettings: MutationUpdatePostSettingsResult;
  updatePostTranslations: MutationUpdatePostTranslationsResult;
  updateReactionEmojis: MutationUpdateReactionEmojisResult;
  updateWelcomeEmail: MutationUpdateWelcomeEmailResult;
  upsertLeadMagnetForm: MutationUpsertLeadMagnetFormResult;
  upsertPublication: MutationUpsertPublicationResult;
};


export type MutationArchivePostArgs = {
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationCancelStripeSetupArgs = {
  publicationId: Scalars['ID']['input'];
};


export type MutationCancelSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangePostMainLocaleArgs = {
  id: Scalars['ID']['input'];
  newLocale: Scalars['Locale']['input'];
};


export type MutationClaimLeadMagnetFormArgs = {
  formId: Scalars['String']['input'];
};


export type MutationCreateCustomerPortalSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateNoteArgs = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  postId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<NoteTypeEnum>;
};


export type MutationCreatePostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLeadMagnetFormArgs = {
  formId: Scalars['ID']['input'];
};


export type MutationDeleteMessageArgs = {
  messageId: Scalars['String']['input'];
};


export type MutationDeleteNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateTranslationArgs = {
  locale: Scalars['Locale']['input'];
  postId: Scalars['ID']['input'];
};


export type MutationMarkThreadReadArgs = {
  threadId: Scalars['String']['input'];
};


export type MutationMarkTranslationAsUpdatedArgs = {
  locale: Scalars['Locale']['input'];
  postId: Scalars['ID']['input'];
};


export type MutationProofreadArgs = {
  input: ProofreadInput;
};


export type MutationPublishPostArgs = {
  id: Scalars['ID']['input'];
  private: Scalars['Boolean']['input'];
  sendEmail: Scalars['Boolean']['input'];
  sendToAll: Scalars['Boolean']['input'];
};


export type MutationRestorePostVersionArgs = {
  versionId: Scalars['ID']['input'];
};


export type MutationSavePostArgs = {
  id: Scalars['ID']['input'];
  input: SavePostInput;
  locale?: InputMaybe<Scalars['Locale']['input']>;
};


export type MutationSendMessageArgs = {
  content: Scalars['String']['input'];
  format?: InputMaybe<MessageFormat>;
  locale?: InputMaybe<Scalars['Locale']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendTestPostEmailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetTagsArgs = {
  tags: Array<Scalars['String']['input']>;
  targetId: Scalars['ID']['input'];
  targetType: TagTargetType;
};


export type MutationSetTranslationsArgs = {
  locales: Array<Scalars['Locale']['input']>;
  postId: Scalars['ID']['input'];
};


export type MutationSetUserBannedArgs = {
  banned: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSkipOnboardingTaskArgs = {
  id: OnboardingTaskKey;
};


export type MutationSubscribeToArgs = {
  formId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  targetUserId: Scalars['String']['input'];
};


export type MutationToggleReactionArgs = {
  emoji: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};


export type MutationTranslateFieldsArgs = {
  fields: Array<TranslateFieldInput>;
};


export type MutationTranslateMessageArgs = {
  messageId: Scalars['String']['input'];
  toLocale: Scalars['Locale']['input'];
};


export type MutationUnlinkStripeAccountArgs = {
  publicationId: Scalars['ID']['input'];
};


export type MutationUnsubscribeFromArgs = {
  targetUserId: Scalars['ID']['input'];
};


export type MutationUpdateCurrentPublicationArgs = {
  input: UpdatePublicationInput;
};


export type MutationUpdateCurrentUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateNoteArgs = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateOptOutFeaturedPostsArgs = {
  optOutFeaturedPosts: Scalars['Boolean']['input'];
};


export type MutationUpdatePostSettingsArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePostSettingsInput;
};


export type MutationUpdatePostTranslationsArgs = {
  locales: Array<Scalars['Locale']['input']>;
  mainLocale: Scalars['Locale']['input'];
  postId: Scalars['ID']['input'];
};


export type MutationUpdateReactionEmojisArgs = {
  reactionEmojis: Scalars['String']['input'];
};


export type MutationUpdateWelcomeEmailArgs = {
  input: UpdateWelcomeEmailInput;
};


export type MutationUpsertLeadMagnetFormArgs = {
  input: UpsertLeadMagnetFormInput;
};


export type MutationUpsertPublicationArgs = {
  input: UpsertPublicationInput;
};

export type MutationArchivePostResult = BaseError | MutationArchivePostSuccess;

export type MutationArchivePostSuccess = {
  __typename?: 'MutationArchivePostSuccess';
  data: Post;
};

export type MutationCancelStripeSetupResult = BaseError | MutationCancelStripeSetupSuccess;

export type MutationCancelStripeSetupSuccess = {
  __typename?: 'MutationCancelStripeSetupSuccess';
  data: CancelStripeSetupResult;
};

export type MutationCancelSubscriptionResult = BaseError | MutationCancelSubscriptionSuccess;

export type MutationCancelSubscriptionSuccess = {
  __typename?: 'MutationCancelSubscriptionSuccess';
  data: CancelSubscriptionResult;
};

export type MutationChangePostMainLocaleResult = BaseError | MutationChangePostMainLocaleSuccess;

export type MutationChangePostMainLocaleSuccess = {
  __typename?: 'MutationChangePostMainLocaleSuccess';
  data: Post;
};

export type MutationClaimLeadMagnetFormResult = BaseError | MutationClaimLeadMagnetFormSuccess;

export type MutationClaimLeadMagnetFormSuccess = {
  __typename?: 'MutationClaimLeadMagnetFormSuccess';
  data: Scalars['Boolean']['output'];
};

export type MutationCreateCustomerPortalSessionResult = BaseError | MutationCreateCustomerPortalSessionSuccess;

export type MutationCreateCustomerPortalSessionSuccess = {
  __typename?: 'MutationCreateCustomerPortalSessionSuccess';
  data: CustomerPortalSessionResult;
};

export type MutationCreateNoteResult = BaseError | MutationCreateNoteSuccess;

export type MutationCreateNoteSuccess = {
  __typename?: 'MutationCreateNoteSuccess';
  data: Note;
};

export type MutationCreatePostResult = BaseError | MutationCreatePostSuccess;

export type MutationCreatePostSuccess = {
  __typename?: 'MutationCreatePostSuccess';
  data: Post;
};

export type MutationCreatePublicationExportResult = BaseError | MutationCreatePublicationExportSuccess;

export type MutationCreatePublicationExportSuccess = {
  __typename?: 'MutationCreatePublicationExportSuccess';
  data: PublicationExport;
};

export type MutationDeleteCurrentUserResult = BaseError | MutationDeleteCurrentUserSuccess;

export type MutationDeleteCurrentUserSuccess = {
  __typename?: 'MutationDeleteCurrentUserSuccess';
  data: Scalars['Boolean']['output'];
};

export type MutationDeleteLeadMagnetFormResult = BaseError | MutationDeleteLeadMagnetFormSuccess;

export type MutationDeleteLeadMagnetFormSuccess = {
  __typename?: 'MutationDeleteLeadMagnetFormSuccess';
  data: Scalars['ID']['output'];
};

export type MutationDeleteMessageResult = BaseError | MutationDeleteMessageSuccess;

export type MutationDeleteMessageSuccess = {
  __typename?: 'MutationDeleteMessageSuccess';
  data: Scalars['Boolean']['output'];
};

export type MutationDeleteNoteResult = BaseError | MutationDeleteNoteSuccess;

export type MutationDeleteNoteSuccess = {
  __typename?: 'MutationDeleteNoteSuccess';
  data: Scalars['Boolean']['output'];
};

export type MutationDeletePostResult = BaseError | MutationDeletePostSuccess;

export type MutationDeletePostSuccess = {
  __typename?: 'MutationDeletePostSuccess';
  data: Scalars['Boolean']['output'];
};

export type MutationGenerateTranslationResult = BaseError | MutationGenerateTranslationSuccess;

export type MutationGenerateTranslationSuccess = {
  __typename?: 'MutationGenerateTranslationSuccess';
  data: Post;
};

export type MutationMarkTranslationAsUpdatedResult = BaseError | MutationMarkTranslationAsUpdatedSuccess;

export type MutationMarkTranslationAsUpdatedSuccess = {
  __typename?: 'MutationMarkTranslationAsUpdatedSuccess';
  data: Post;
};

export type MutationProofreadResult = BaseError | MutationProofreadSuccess;

export type MutationProofreadSuccess = {
  __typename?: 'MutationProofreadSuccess';
  data: ProofreadResult;
};

export type MutationPublishPostResult = BaseError | MutationPublishPostSuccess;

export type MutationPublishPostSuccess = {
  __typename?: 'MutationPublishPostSuccess';
  data: Post;
};

export type MutationRestorePostVersionResult = BaseError | MutationRestorePostVersionSuccess;

export type MutationRestorePostVersionSuccess = {
  __typename?: 'MutationRestorePostVersionSuccess';
  data: Post;
};

export type MutationSavePostResult = BaseError | MutationSavePostSuccess;

export type MutationSavePostSuccess = {
  __typename?: 'MutationSavePostSuccess';
  data: Post;
};

export type MutationSendMessageResult = BaseError | FlaggedMessageError | MutationSendMessageSuccess;

export type MutationSendMessageSuccess = {
  __typename?: 'MutationSendMessageSuccess';
  data: Thread;
};

export type MutationSendTestPostEmailResult = BaseError | MutationSendTestPostEmailSuccess;

export type MutationSendTestPostEmailSuccess = {
  __typename?: 'MutationSendTestPostEmailSuccess';
  data: Scalars['Boolean']['output'];
};

export type MutationSetTagsResult = BaseError | MutationSetTagsSuccess;

export type MutationSetTagsSuccess = {
  __typename?: 'MutationSetTagsSuccess';
  data: Tags;
};

export type MutationSetTranslationsResult = BaseError | MutationSetTranslationsSuccess;

export type MutationSetTranslationsSuccess = {
  __typename?: 'MutationSetTranslationsSuccess';
  data: Post;
};

export type MutationSetUserBannedResult = BaseError | MutationSetUserBannedSuccess;

export type MutationSetUserBannedSuccess = {
  __typename?: 'MutationSetUserBannedSuccess';
  data: Scalars['Boolean']['output'];
};

export type MutationSkipOnboardingTaskResult = BaseError | MutationSkipOnboardingTaskSuccess;

export type MutationSkipOnboardingTaskSuccess = {
  __typename?: 'MutationSkipOnboardingTaskSuccess';
  data: OnboardingTask;
};

export type MutationSubscribeToResult = BaseError | MutationSubscribeToSuccess;

export type MutationSubscribeToSuccess = {
  __typename?: 'MutationSubscribeToSuccess';
  data: User;
};

export type MutationTranslateFieldsResult = BaseError | MutationTranslateFieldsSuccess;

export type MutationTranslateFieldsSuccess = {
  __typename?: 'MutationTranslateFieldsSuccess';
  data: TranslateFieldsResult;
};

export type MutationTranslateMessageResult = BaseError | MutationTranslateMessageSuccess;

export type MutationTranslateMessageSuccess = {
  __typename?: 'MutationTranslateMessageSuccess';
  data: TranslateMessageResult;
};

export type MutationUnlinkStripeAccountResult = BaseError | MutationUnlinkStripeAccountSuccess;

export type MutationUnlinkStripeAccountSuccess = {
  __typename?: 'MutationUnlinkStripeAccountSuccess';
  data: UnlinkStripeAccountResult;
};

export type MutationUnsubscribeFromResult = BaseError | MutationUnsubscribeFromSuccess;

export type MutationUnsubscribeFromSuccess = {
  __typename?: 'MutationUnsubscribeFromSuccess';
  data: Sub;
};

export type MutationUpdateCurrentPublicationResult = BaseError | MutationUpdateCurrentPublicationSuccess;

export type MutationUpdateCurrentPublicationSuccess = {
  __typename?: 'MutationUpdateCurrentPublicationSuccess';
  data: Publication;
};

export type MutationUpdateCurrentUserResult = BaseError | MutationUpdateCurrentUserSuccess;

export type MutationUpdateCurrentUserSuccess = {
  __typename?: 'MutationUpdateCurrentUserSuccess';
  data: Me;
};

export type MutationUpdateNoteResult = BaseError | MutationUpdateNoteSuccess;

export type MutationUpdateNoteSuccess = {
  __typename?: 'MutationUpdateNoteSuccess';
  data: Note;
};

export type MutationUpdateOptOutFeaturedPostsResult = BaseError | MutationUpdateOptOutFeaturedPostsSuccess;

export type MutationUpdateOptOutFeaturedPostsSuccess = {
  __typename?: 'MutationUpdateOptOutFeaturedPostsSuccess';
  data: Publication;
};

export type MutationUpdatePostSettingsResult = BaseError | MutationUpdatePostSettingsSuccess;

export type MutationUpdatePostSettingsSuccess = {
  __typename?: 'MutationUpdatePostSettingsSuccess';
  data: Post;
};

export type MutationUpdatePostTranslationsResult = BaseError | MutationUpdatePostTranslationsSuccess;

export type MutationUpdatePostTranslationsSuccess = {
  __typename?: 'MutationUpdatePostTranslationsSuccess';
  data: Post;
};

export type MutationUpdateReactionEmojisResult = BaseError | MutationUpdateReactionEmojisSuccess;

export type MutationUpdateReactionEmojisSuccess = {
  __typename?: 'MutationUpdateReactionEmojisSuccess';
  data: Publication;
};

export type MutationUpdateWelcomeEmailResult = BaseError | MutationUpdateWelcomeEmailSuccess;

export type MutationUpdateWelcomeEmailSuccess = {
  __typename?: 'MutationUpdateWelcomeEmailSuccess';
  data: Publication;
};

export type MutationUpsertLeadMagnetFormResult = BaseError | MutationUpsertLeadMagnetFormSuccess;

export type MutationUpsertLeadMagnetFormSuccess = {
  __typename?: 'MutationUpsertLeadMagnetFormSuccess';
  data: LeadMagnetForm;
};

export type MutationUpsertPublicationResult = BaseError | MutationUpsertPublicationSuccess;

export type MutationUpsertPublicationSuccess = {
  __typename?: 'MutationUpsertPublicationSuccess';
  data: Me;
};

export type NotFoundError = Error & {
  __typename?: 'NotFoundError';
  message: Scalars['String']['output'];
};

export type Note = {
  __typename?: 'Note';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  posts: Array<Post>;
  suggestedTags?: Maybe<Array<Scalars['String']['output']>>;
  tags: Tags;
  type: NoteTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export enum NoteTypeEnum {
  User = 'user',
  Voice = 'voice'
}

export type OEmbedData = {
  __typename?: 'OEmbedData';
  embedHeight?: Maybe<Scalars['Int']['output']>;
  embedHtml?: Maybe<Scalars['String']['output']>;
  embedUrl?: Maybe<Scalars['String']['output']>;
  embedWidth?: Maybe<Scalars['Int']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  thumbnailHeight?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  thumbnailWidth?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OEmbedMetadata = {
  __typename?: 'OEmbedMetadata';
  description?: Maybe<Scalars['String']['output']>;
  faviconUrl?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type OEmbedResult = {
  __typename?: 'OEmbedResult';
  metadata: OEmbedMetadata;
  oembed?: Maybe<OEmbedData>;
  url: Scalars['String']['output'];
};

export enum OnboardingStage {
  Completed = 'completed',
  PostContent = 'post_content',
  PreviewPublication = 'preview_publication',
  SetUsername = 'set_username'
}

export type OnboardingTask = {
  __typename?: 'OnboardingTask';
  id: OnboardingTaskKey;
  status: OnboardingTaskStatus;
};

export enum OnboardingTaskKey {
  CreateFirstPost = 'create_first_post',
  CreateSecondPost = 'create_second_post',
  FillProfile = 'fill_profile',
  FillPublication = 'fill_publication',
  SetLanguage = 'set_language',
  TranslateArticles = 'translate_articles'
}

export enum OnboardingTaskStatus {
  Completed = 'completed',
  Pending = 'pending',
  Skipped = 'skipped'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Post = {
  __typename?: 'Post';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  availableLocales: Array<Scalars['Locale']['output']>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentVersion?: Maybe<PostVersion>;
  currentVersions: Array<PostVersion>;
  firstPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  form?: Maybe<LeadMagnetForm>;
  formId?: Maybe<Scalars['String']['output']>;
  humanContent?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  mainLocale: Scalars['Locale']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  pinnedAt?: Maybe<Scalars['DateTime']['output']>;
  private: Scalars['Boolean']['output'];
  publication: Publication;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedVersion?: Maybe<PostVersion>;
  publishedVersions: Array<PostVersion>;
  reactions: Array<ReactionSummary>;
  relatedNotes: Array<Note>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  spamScore?: Maybe<Scalars['Int']['output']>;
  stat?: Maybe<PostStat>;
  subscriberCount: Scalars['Int']['output'];
  suggestedTags?: Maybe<Array<Scalars['String']['output']>>;
  tags: Tags;
  tiers: Array<SubscriptionTier>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  usedProofreaderAt?: Maybe<Scalars['DateTime']['output']>;
  versions: PostVersionsConnection;
};


export type PostCurrentVersionArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};


export type PostPublishedVersionArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};


export type PostUrlArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PostVersionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type PostHighlight = {
  __typename?: 'PostHighlight';
  content?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum PostOrder {
  CreatedAt = 'createdAt',
  LastEditAt = 'lastEditAt',
  PublishedAt = 'publishedAt',
  TextMatch = 'textMatch'
}

export enum PostOrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type PostOrderInput = {
  direction: PostOrderDirection;
  field: PostOrder;
};

export type PostSearch = {
  __typename?: 'PostSearch';
  highlight?: Maybe<PostHighlight>;
  id: Scalars['ID']['output'];
  post: Post;
  rank: Scalars['Float']['output'];
};

export type PostStat = {
  __typename?: 'PostStat';
  id: Scalars['ID']['output'];
  openRatePercent?: Maybe<Scalars['Float']['output']>;
  recentViews: Scalars['Int']['output'];
};

export type PostStatsItem = {
  __typename?: 'PostStatsItem';
  /** Cumulative total of posts published up to and including this day */
  amount: Scalars['Int']['output'];
  /** ISO date string for the day (YYYY-MM-DD) */
  day: Scalars['String']['output'];
};

export enum PostStatus {
  Archived = 'archived',
  Draft = 'draft',
  Published = 'published',
  Sent = 'sent',
  Spam = 'spam'
}

export type PostVersion = {
  __typename?: 'PostVersion';
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageHeaderUrl?: Maybe<Scalars['String']['output']>;
  locale: Scalars['Locale']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  postId: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  sent: Scalars['Boolean']['output'];
  socialImageUrl?: Maybe<Scalars['String']['output']>;
  socialImageUrls: SocialImageUrls;
  title: Scalars['String']['output'];
  translated: Scalars['Boolean']['output'];
  translatedContent?: Maybe<Scalars['String']['output']>;
  translatedDescription?: Maybe<Scalars['String']['output']>;
  translatedTitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PostVersionsConnection = {
  __typename?: 'PostVersionsConnection';
  edges: Array<PostVersionsConnectionEdge>;
  pageInfo: PageInfo;
};

export type PostVersionsConnectionEdge = {
  __typename?: 'PostVersionsConnectionEdge';
  cursor: Scalars['String']['output'];
  node: PostVersion;
};

export type ProofreadInput = {
  chunk: Scalars['String']['input'];
  context: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['Locale']['input']>;
  postId: Scalars['String']['input'];
  principle: ProofreadPrinciple;
};

export enum ProofreadPrinciple {
  Grammar = 'grammar',
  Refine = 'refine',
  Tighten = 'tighten'
}

export type ProofreadResult = {
  __typename?: 'ProofreadResult';
  text?: Maybe<Scalars['String']['output']>;
};

export type Publication = {
  __typename?: 'Publication';
  additionalLanguages: Array<Scalars['Locale']['output']>;
  author: User;
  blogFooter?: Maybe<Scalars['String']['output']>;
  blogHeader?: Maybe<Scalars['String']['output']>;
  channelStats: Array<TableStatsItem>;
  countryStats: Array<TableStatsItem>;
  currentFeePercent: Scalars['Int']['output'];
  dailyViews: Array<PostStatsItem>;
  description?: Maybe<Scalars['String']['output']>;
  enableMonetization: Scalars['Boolean']['output'];
  faviconUrl?: Maybe<Scalars['String']['output']>;
  feeLevels: Array<FeeLevelEntry>;
  id: Scalars['ID']['output'];
  leadMagnetForms: Array<LeadMagnetForm>;
  locale: Scalars['Locale']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nameChangeCooldownDays?: Maybe<Scalars['Int']['output']>;
  openRatesStats?: Maybe<PublicationOpenRatesStats>;
  optOutFeaturedPosts: Scalars['Boolean']['output'];
  paidSubscribersCount: Scalars['Int']['output'];
  publisherId: Scalars['String']['output'];
  reactionEmojis?: Maybe<Scalars['String']['output']>;
  referrerStats: Array<TableStatsItem>;
  stripe?: Maybe<Stripe>;
  sub?: Maybe<Sub>;
  subscriberStats: Array<PostStatsItem>;
  subscribers: PublicationSubscribersConnection;
  subscribersCount: Scalars['Int']['output'];
  subscriptionTiers: Array<SubscriptionTier>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  viewStats?: Maybe<PublicationViewStats>;
  welcomeEmailContent?: Maybe<Scalars['String']['output']>;
  welcomeEmailSubject?: Maybe<Scalars['String']['output']>;
  welcomeImageUrl?: Maybe<Scalars['String']['output']>;
  wordmarkUrl?: Maybe<Scalars['String']['output']>;
};


export type PublicationChannelStatsArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
};


export type PublicationCountryStatsArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
};


export type PublicationReferrerStatsArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
};


export type PublicationSubscriberStatsArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type PublicationSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tierId?: InputMaybe<Scalars['String']['input']>;
};

export type PublicationExport = {
  __typename?: 'PublicationExport';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  numPosts?: Maybe<Scalars['Int']['output']>;
  numSubscribers?: Maybe<Scalars['Int']['output']>;
  publicationId: Scalars['String']['output'];
};

export type PublicationOpenRatesStats = {
  __typename?: 'PublicationOpenRatesStats';
  currentMonthEmailsSent: Scalars['Int']['output'];
  currentMonthOpenRatePercent: Scalars['Float']['output'];
  previousMonthEmailsSent: Scalars['Int']['output'];
  previousMonthOpenRatePercent: Scalars['Float']['output'];
};

export type PublicationSubscribersConnection = {
  __typename?: 'PublicationSubscribersConnection';
  edges: Array<PublicationSubscribersConnectionEdge>;
  pageInfo: PageInfo;
};

export type PublicationSubscribersConnectionEdge = {
  __typename?: 'PublicationSubscribersConnectionEdge';
  cursor: Scalars['String']['output'];
  node: Subscriber;
};

export type PublicationViewStats = {
  __typename?: 'PublicationViewStats';
  change: Scalars['Int']['output'];
  currentPeriodViews: Scalars['Int']['output'];
  percentChange?: Maybe<Scalars['Float']['output']>;
  previousPeriodViews: Scalars['Int']['output'];
};

export type PublishedPost = {
  __typename?: 'PublishedPost';
  comments: Array<Thread>;
  commentsEnabled: Scalars['Boolean']['output'];
  content?: Maybe<Scalars['String']['output']>;
  contentAccess: ContentAccess;
  description?: Maybe<Scalars['String']['output']>;
  featuredAt?: Maybe<Scalars['DateTime']['output']>;
  firstPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  humanContent?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  publication: Publication;
  reactions: Array<ReactionSummary>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  inbox: Array<Thread>;
  latestPostNotes: QueryLatestPostNotesConnection;
  me?: Maybe<Me>;
  myPublication?: Maybe<Publication>;
  oembed?: Maybe<OEmbedResult>;
  onboardingTask?: Maybe<OnboardingTask>;
  post?: Maybe<Post>;
  postComments: Array<Thread>;
  postStats: Array<PostStatsItem>;
  posts: QueryPostsConnection;
  publication?: Maybe<Publication>;
  publicationExports: Array<PublicationExport>;
  publishedPost?: Maybe<PublishedPost>;
  publishedPosts: QueryPublishedPostsConnection;
  recentReactions: Array<GroupedReaction>;
  /** @deprecated Publication discovery has been retired. */
  recommendedPublications: Array<Publication>;
  sub?: Maybe<Sub>;
  subs: QuerySubsConnection;
  tagOptions: Array<Scalars['String']['output']>;
  thread?: Maybe<Thread>;
  unreadThreadCount: Scalars['Int']['output'];
};


export type QueryInboxArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLatestPostNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOembedArgs = {
  url: Scalars['String']['input'];
};


export type QueryOnboardingTaskArgs = {
  id: OnboardingTaskKey;
};


export type QueryPostArgs = {
  id: Scalars['String']['input'];
};


export type QueryPostCommentsArgs = {
  postId: Scalars['String']['input'];
};


export type QueryPostStatsArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<PostOrderInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<PostStatus>>;
  tag?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPublicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublishedPostArgs = {
  id: Scalars['String']['input'];
};


export type QueryPublishedPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inMyLanguages?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  subscribed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRecentReactionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubArgs = {
  id: Scalars['String']['input'];
};


export type QuerySubsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagOptionsArgs = {
  targetType: TagTargetType;
};


export type QueryThreadArgs = {
  id: Scalars['String']['input'];
};


export type QueryUnreadThreadCountArgs = {
  private?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryLatestPostNotesConnection = {
  __typename?: 'QueryLatestPostNotesConnection';
  edges: Array<QueryLatestPostNotesConnectionEdge>;
  pageInfo: PageInfo;
};

export type QueryLatestPostNotesConnectionEdge = {
  __typename?: 'QueryLatestPostNotesConnectionEdge';
  cursor: Scalars['String']['output'];
  node: Note;
};

export type QueryPostsConnection = {
  __typename?: 'QueryPostsConnection';
  edges: Array<QueryPostsConnectionEdge>;
  pageInfo: PageInfo;
};

export type QueryPostsConnectionEdge = {
  __typename?: 'QueryPostsConnectionEdge';
  cursor: Scalars['String']['output'];
  node: PostSearch;
};

export type QueryPublishedPostsConnection = {
  __typename?: 'QueryPublishedPostsConnection';
  edges: Array<QueryPublishedPostsConnectionEdge>;
  pageInfo: PageInfo;
};

export type QueryPublishedPostsConnectionEdge = {
  __typename?: 'QueryPublishedPostsConnectionEdge';
  cursor: Scalars['String']['output'];
  node: PublishedPost;
};

export type QuerySubsConnection = {
  __typename?: 'QuerySubsConnection';
  edges: Array<QuerySubsConnectionEdge>;
  pageInfo: PageInfo;
};

export type QuerySubsConnectionEdge = {
  __typename?: 'QuerySubsConnectionEdge';
  cursor: Scalars['String']['output'];
  node: Sub;
};

export type ReactionSummary = {
  __typename?: 'ReactionSummary';
  count: Scalars['Int']['output'];
  emoji: Scalars['String']['output'];
  reacted: Scalars['Boolean']['output'];
};

export type SavePostInput = {
  content: Scalars['String']['input'];
  description: Scalars['String']['input'];
  imageHeaderUrl: Scalars['String']['input'];
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  socialImageUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type SocialImageUrls = {
  __typename?: 'SocialImageUrls';
  landscape: Scalars['String']['output'];
  portrait: Scalars['String']['output'];
  square: Scalars['String']['output'];
  story: Scalars['String']['output'];
};

export type Stripe = {
  __typename?: 'Stripe';
  accountId?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  dashboardUrl?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  setupComplete: Scalars['Boolean']['output'];
};

export type StripePrice = {
  __typename?: 'StripePrice';
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval: Scalars['String']['output'];
  unitAmount: Scalars['Int']['output'];
};

export type Sub = {
  __typename?: 'Sub';
  billingInterval?: Maybe<Scalars['String']['output']>;
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  post?: Maybe<Post>;
  publication: Publication;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscribedAt?: Maybe<Scalars['DateTime']['output']>;
  tier?: Maybe<SubscriptionTier>;
};

export type Subscriber = {
  __typename?: 'Subscriber';
  email: Scalars['String']['output'];
  form?: Maybe<LeadMagnetForm>;
  formName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  searchResult?: Maybe<SubscriberSearchResult>;
  subscribedAt: Scalars['DateTime']['output'];
  tier?: Maybe<SubscriptionTier>;
  user: User;
};

export type SubscriberHighlight = {
  __typename?: 'SubscriberHighlight';
  email?: Maybe<Scalars['String']['output']>;
};

export type SubscriberSearchResult = {
  __typename?: 'SubscriberSearchResult';
  highlight?: Maybe<SubscriberHighlight>;
  rank: Scalars['Float']['output'];
};

export type SubscriptionTier = {
  __typename?: 'SubscriptionTier';
  annualPriceCents?: Maybe<Scalars['Int']['output']>;
  canPurchase: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  monthlyPriceCents: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  publication: Publication;
  stripeAnnualPriceId?: Maybe<Scalars['String']['output']>;
  stripeMonthlyPriceId?: Maybe<Scalars['String']['output']>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  subscriberCount: Scalars['Int']['output'];
};

export type TableStatsItem = {
  __typename?: 'TableStatsItem';
  label: Scalars['String']['output'];
  pageviews: Scalars['Int']['output'];
  visitors: Scalars['Int']['output'];
};

export enum TagTargetType {
  Post = 'post',
  UserNote = 'user_note'
}

export type Tags = {
  __typename?: 'Tags';
  id: Scalars['ID']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type Thread = {
  __typename?: 'Thread';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastMessage?: Maybe<Message>;
  messages: Array<Message>;
  participantCount: Scalars['Int']['output'];
  participants: Array<User>;
  post?: Maybe<PublishedPost>;
  postId?: Maybe<Scalars['String']['output']>;
  private: Scalars['Boolean']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  unreadCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TranslateFieldInput = {
  fromLocale: Scalars['Locale']['input'];
  id: Scalars['String']['input'];
  toLocale: Scalars['Locale']['input'];
  value: Scalars['String']['input'];
};

export type TranslateFieldsResult = {
  __typename?: 'TranslateFieldsResult';
  results: Scalars['String']['output'];
};

export type TranslateMessageResult = {
  __typename?: 'TranslateMessageResult';
  renderedContent: Scalars['String']['output'];
  translatedContent: Scalars['String']['output'];
};

export type UnauthorizedError = Error & {
  __typename?: 'UnauthorizedError';
  message: Scalars['String']['output'];
};

export type UnlinkStripeAccountResult = {
  __typename?: 'UnlinkStripeAccountResult';
  publication: Publication;
};

export type UpdatePostSettingsInput = {
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  commentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  firstPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  pinnedAt?: InputMaybe<Scalars['DateTime']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePublicationInput = {
  additionalLanguages?: InputMaybe<Array<Scalars['Locale']['input']>>;
  blogFooter?: InputMaybe<Scalars['String']['input']>;
  blogHeader?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  faviconUrl?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['Locale']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  welcomeImageUrl?: InputMaybe<Scalars['String']['input']>;
  wordmarkUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  interestCategories?: InputMaybe<Scalars['String']['input']>;
  interfaceLocale?: InputMaybe<Scalars['Locale']['input']>;
  onboardingStage?: InputMaybe<OnboardingStage>;
  profileImage?: InputMaybe<Scalars['String']['input']>;
  readerOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  socialBandcamp?: InputMaybe<Scalars['String']['input']>;
  socialBluesky?: InputMaybe<Scalars['String']['input']>;
  socialBooks?: InputMaybe<Scalars['String']['input']>;
  socialFacebook?: InputMaybe<Scalars['String']['input']>;
  socialInstagram?: InputMaybe<Scalars['String']['input']>;
  socialLinkedin?: InputMaybe<Scalars['String']['input']>;
  socialSoundcloud?: InputMaybe<Scalars['String']['input']>;
  socialTiktok?: InputMaybe<Scalars['String']['input']>;
  socialWebsite?: InputMaybe<Scalars['String']['input']>;
  socialX?: InputMaybe<Scalars['String']['input']>;
  socialYoutube?: InputMaybe<Scalars['String']['input']>;
  weeklyFeaturedPostsUnsubscribed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateWelcomeEmailInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertLeadMagnetFormInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailSubject: Scalars['String']['input'];
  files?: InputMaybe<Array<LeadMagnetFormFileInput>>;
  formId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  private: Scalars['Boolean']['input'];
};

export type UpsertPublicationInput = {
  name: Scalars['String']['input'];
};

export type User = UserInterface & {
  __typename?: 'User';
  authorName?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  followsYou: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isMe: Scalars['Boolean']['output'];
  profileImage?: Maybe<Scalars['String']['output']>;
  publication?: Maybe<Publication>;
  publicationUrl?: Maybe<Scalars['String']['output']>;
  socialBandcamp?: Maybe<Scalars['String']['output']>;
  socialBluesky?: Maybe<Scalars['String']['output']>;
  socialBooks?: Maybe<Scalars['String']['output']>;
  socialFacebook?: Maybe<Scalars['String']['output']>;
  socialInstagram?: Maybe<Scalars['String']['output']>;
  socialLinkedin?: Maybe<Scalars['String']['output']>;
  socialSoundcloud?: Maybe<Scalars['String']['output']>;
  socialTiktok?: Maybe<Scalars['String']['output']>;
  socialWebsite?: Maybe<Scalars['String']['output']>;
  socialX?: Maybe<Scalars['String']['output']>;
  socialYoutube?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type UserInterface = {
  authorName?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  profileImage?: Maybe<Scalars['String']['output']>;
  publication?: Maybe<Publication>;
  socialBandcamp?: Maybe<Scalars['String']['output']>;
  socialBluesky?: Maybe<Scalars['String']['output']>;
  socialBooks?: Maybe<Scalars['String']['output']>;
  socialFacebook?: Maybe<Scalars['String']['output']>;
  socialInstagram?: Maybe<Scalars['String']['output']>;
  socialLinkedin?: Maybe<Scalars['String']['output']>;
  socialSoundcloud?: Maybe<Scalars['String']['output']>;
  socialTiktok?: Maybe<Scalars['String']['output']>;
  socialWebsite?: Maybe<Scalars['String']['output']>;
  socialX?: Maybe<Scalars['String']['output']>;
  socialYoutube?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type ValidationError = Error & {
  __typename?: 'ValidationError';
  message: Scalars['String']['output'];
};

export type WithTypename<T extends { __typename?: any }> = Partial<T> & { __typename: NonNullable<T['__typename']> };

export type GraphCacheKeysConfig = {
  BaseError?: (data: WithTypename<BaseError>) => null | string,
  CancelStripeSetupResult?: (data: WithTypename<CancelStripeSetupResult>) => null | string,
  CancelSubscriptionResult?: (data: WithTypename<CancelSubscriptionResult>) => null | string,
  ContentAccess?: (data: WithTypename<ContentAccess>) => null | string,
  CustomerPortalSessionResult?: (data: WithTypename<CustomerPortalSessionResult>) => null | string,
  FeeLevelEntry?: (data: WithTypename<FeeLevelEntry>) => null | string,
  FlaggedMessageError?: (data: WithTypename<FlaggedMessageError>) => null | string,
  GroupedReaction?: (data: WithTypename<GroupedReaction>) => null | string,
  LeadMagnetFile?: (data: WithTypename<LeadMagnetFile>) => null | string,
  LeadMagnetForm?: (data: WithTypename<LeadMagnetForm>) => null | string,
  Me?: (data: WithTypename<Me>) => null | string,
  Message?: (data: WithTypename<Message>) => null | string,
  MutationArchivePostSuccess?: (data: WithTypename<MutationArchivePostSuccess>) => null | string,
  MutationCancelStripeSetupSuccess?: (data: WithTypename<MutationCancelStripeSetupSuccess>) => null | string,
  MutationCancelSubscriptionSuccess?: (data: WithTypename<MutationCancelSubscriptionSuccess>) => null | string,
  MutationChangePostMainLocaleSuccess?: (data: WithTypename<MutationChangePostMainLocaleSuccess>) => null | string,
  MutationClaimLeadMagnetFormSuccess?: (data: WithTypename<MutationClaimLeadMagnetFormSuccess>) => null | string,
  MutationCreateCustomerPortalSessionSuccess?: (data: WithTypename<MutationCreateCustomerPortalSessionSuccess>) => null | string,
  MutationCreateNoteSuccess?: (data: WithTypename<MutationCreateNoteSuccess>) => null | string,
  MutationCreatePostSuccess?: (data: WithTypename<MutationCreatePostSuccess>) => null | string,
  MutationCreatePublicationExportSuccess?: (data: WithTypename<MutationCreatePublicationExportSuccess>) => null | string,
  MutationDeleteCurrentUserSuccess?: (data: WithTypename<MutationDeleteCurrentUserSuccess>) => null | string,
  MutationDeleteLeadMagnetFormSuccess?: (data: WithTypename<MutationDeleteLeadMagnetFormSuccess>) => null | string,
  MutationDeleteMessageSuccess?: (data: WithTypename<MutationDeleteMessageSuccess>) => null | string,
  MutationDeleteNoteSuccess?: (data: WithTypename<MutationDeleteNoteSuccess>) => null | string,
  MutationDeletePostSuccess?: (data: WithTypename<MutationDeletePostSuccess>) => null | string,
  MutationGenerateTranslationSuccess?: (data: WithTypename<MutationGenerateTranslationSuccess>) => null | string,
  MutationMarkTranslationAsUpdatedSuccess?: (data: WithTypename<MutationMarkTranslationAsUpdatedSuccess>) => null | string,
  MutationProofreadSuccess?: (data: WithTypename<MutationProofreadSuccess>) => null | string,
  MutationPublishPostSuccess?: (data: WithTypename<MutationPublishPostSuccess>) => null | string,
  MutationRestorePostVersionSuccess?: (data: WithTypename<MutationRestorePostVersionSuccess>) => null | string,
  MutationSavePostSuccess?: (data: WithTypename<MutationSavePostSuccess>) => null | string,
  MutationSendMessageSuccess?: (data: WithTypename<MutationSendMessageSuccess>) => null | string,
  MutationSendTestPostEmailSuccess?: (data: WithTypename<MutationSendTestPostEmailSuccess>) => null | string,
  MutationSetTagsSuccess?: (data: WithTypename<MutationSetTagsSuccess>) => null | string,
  MutationSetTranslationsSuccess?: (data: WithTypename<MutationSetTranslationsSuccess>) => null | string,
  MutationSetUserBannedSuccess?: (data: WithTypename<MutationSetUserBannedSuccess>) => null | string,
  MutationSkipOnboardingTaskSuccess?: (data: WithTypename<MutationSkipOnboardingTaskSuccess>) => null | string,
  MutationSubscribeToSuccess?: (data: WithTypename<MutationSubscribeToSuccess>) => null | string,
  MutationTranslateFieldsSuccess?: (data: WithTypename<MutationTranslateFieldsSuccess>) => null | string,
  MutationTranslateMessageSuccess?: (data: WithTypename<MutationTranslateMessageSuccess>) => null | string,
  MutationUnlinkStripeAccountSuccess?: (data: WithTypename<MutationUnlinkStripeAccountSuccess>) => null | string,
  MutationUnsubscribeFromSuccess?: (data: WithTypename<MutationUnsubscribeFromSuccess>) => null | string,
  MutationUpdateCurrentPublicationSuccess?: (data: WithTypename<MutationUpdateCurrentPublicationSuccess>) => null | string,
  MutationUpdateCurrentUserSuccess?: (data: WithTypename<MutationUpdateCurrentUserSuccess>) => null | string,
  MutationUpdateNoteSuccess?: (data: WithTypename<MutationUpdateNoteSuccess>) => null | string,
  MutationUpdateOptOutFeaturedPostsSuccess?: (data: WithTypename<MutationUpdateOptOutFeaturedPostsSuccess>) => null | string,
  MutationUpdatePostSettingsSuccess?: (data: WithTypename<MutationUpdatePostSettingsSuccess>) => null | string,
  MutationUpdatePostTranslationsSuccess?: (data: WithTypename<MutationUpdatePostTranslationsSuccess>) => null | string,
  MutationUpdateReactionEmojisSuccess?: (data: WithTypename<MutationUpdateReactionEmojisSuccess>) => null | string,
  MutationUpdateWelcomeEmailSuccess?: (data: WithTypename<MutationUpdateWelcomeEmailSuccess>) => null | string,
  MutationUpsertLeadMagnetFormSuccess?: (data: WithTypename<MutationUpsertLeadMagnetFormSuccess>) => null | string,
  MutationUpsertPublicationSuccess?: (data: WithTypename<MutationUpsertPublicationSuccess>) => null | string,
  NotFoundError?: (data: WithTypename<NotFoundError>) => null | string,
  Note?: (data: WithTypename<Note>) => null | string,
  OEmbedData?: (data: WithTypename<OEmbedData>) => null | string,
  OEmbedMetadata?: (data: WithTypename<OEmbedMetadata>) => null | string,
  OEmbedResult?: (data: WithTypename<OEmbedResult>) => null | string,
  OnboardingTask?: (data: WithTypename<OnboardingTask>) => null | string,
  PageInfo?: (data: WithTypename<PageInfo>) => null | string,
  Post?: (data: WithTypename<Post>) => null | string,
  PostHighlight?: (data: WithTypename<PostHighlight>) => null | string,
  PostSearch?: (data: WithTypename<PostSearch>) => null | string,
  PostStat?: (data: WithTypename<PostStat>) => null | string,
  PostStatsItem?: (data: WithTypename<PostStatsItem>) => null | string,
  PostVersion?: (data: WithTypename<PostVersion>) => null | string,
  PostVersionsConnection?: (data: WithTypename<PostVersionsConnection>) => null | string,
  PostVersionsConnectionEdge?: (data: WithTypename<PostVersionsConnectionEdge>) => null | string,
  ProofreadResult?: (data: WithTypename<ProofreadResult>) => null | string,
  Publication?: (data: WithTypename<Publication>) => null | string,
  PublicationExport?: (data: WithTypename<PublicationExport>) => null | string,
  PublicationOpenRatesStats?: (data: WithTypename<PublicationOpenRatesStats>) => null | string,
  PublicationSubscribersConnection?: (data: WithTypename<PublicationSubscribersConnection>) => null | string,
  PublicationSubscribersConnectionEdge?: (data: WithTypename<PublicationSubscribersConnectionEdge>) => null | string,
  PublicationViewStats?: (data: WithTypename<PublicationViewStats>) => null | string,
  PublishedPost?: (data: WithTypename<PublishedPost>) => null | string,
  QueryLatestPostNotesConnection?: (data: WithTypename<QueryLatestPostNotesConnection>) => null | string,
  QueryLatestPostNotesConnectionEdge?: (data: WithTypename<QueryLatestPostNotesConnectionEdge>) => null | string,
  QueryPostsConnection?: (data: WithTypename<QueryPostsConnection>) => null | string,
  QueryPostsConnectionEdge?: (data: WithTypename<QueryPostsConnectionEdge>) => null | string,
  QueryPublishedPostsConnection?: (data: WithTypename<QueryPublishedPostsConnection>) => null | string,
  QueryPublishedPostsConnectionEdge?: (data: WithTypename<QueryPublishedPostsConnectionEdge>) => null | string,
  QuerySubsConnection?: (data: WithTypename<QuerySubsConnection>) => null | string,
  QuerySubsConnectionEdge?: (data: WithTypename<QuerySubsConnectionEdge>) => null | string,
  ReactionSummary?: (data: WithTypename<ReactionSummary>) => null | string,
  SocialImageUrls?: (data: WithTypename<SocialImageUrls>) => null | string,
  Stripe?: (data: WithTypename<Stripe>) => null | string,
  StripePrice?: (data: WithTypename<StripePrice>) => null | string,
  Sub?: (data: WithTypename<Sub>) => null | string,
  Subscriber?: (data: WithTypename<Subscriber>) => null | string,
  SubscriberHighlight?: (data: WithTypename<SubscriberHighlight>) => null | string,
  SubscriberSearchResult?: (data: WithTypename<SubscriberSearchResult>) => null | string,
  SubscriptionTier?: (data: WithTypename<SubscriptionTier>) => null | string,
  TableStatsItem?: (data: WithTypename<TableStatsItem>) => null | string,
  Tags?: (data: WithTypename<Tags>) => null | string,
  Thread?: (data: WithTypename<Thread>) => null | string,
  TranslateFieldsResult?: (data: WithTypename<TranslateFieldsResult>) => null | string,
  TranslateMessageResult?: (data: WithTypename<TranslateMessageResult>) => null | string,
  UnauthorizedError?: (data: WithTypename<UnauthorizedError>) => null | string,
  UnlinkStripeAccountResult?: (data: WithTypename<UnlinkStripeAccountResult>) => null | string,
  User?: (data: WithTypename<User>) => null | string,
  ValidationError?: (data: WithTypename<ValidationError>) => null | string
}

export type GraphCacheResolvers = {
  Query?: {
    inbox?: GraphCacheResolver<WithTypename<Query>, QueryInboxArgs, Array<WithTypename<Thread> | string>>,
    latestPostNotes?: GraphCacheResolver<WithTypename<Query>, QueryLatestPostNotesArgs, WithTypename<QueryLatestPostNotesConnection> | string>,
    me?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<Me> | string>,
    myPublication?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<Publication> | string>,
    oembed?: GraphCacheResolver<WithTypename<Query>, QueryOembedArgs, WithTypename<OEmbedResult> | string>,
    onboardingTask?: GraphCacheResolver<WithTypename<Query>, QueryOnboardingTaskArgs, WithTypename<OnboardingTask> | string>,
    post?: GraphCacheResolver<WithTypename<Query>, QueryPostArgs, WithTypename<Post> | string>,
    postComments?: GraphCacheResolver<WithTypename<Query>, QueryPostCommentsArgs, Array<WithTypename<Thread> | string>>,
    postStats?: GraphCacheResolver<WithTypename<Query>, QueryPostStatsArgs, Array<WithTypename<PostStatsItem> | string>>,
    posts?: GraphCacheResolver<WithTypename<Query>, QueryPostsArgs, WithTypename<QueryPostsConnection> | string>,
    publication?: GraphCacheResolver<WithTypename<Query>, QueryPublicationArgs, WithTypename<Publication> | string>,
    publicationExports?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<PublicationExport> | string>>,
    publishedPost?: GraphCacheResolver<WithTypename<Query>, QueryPublishedPostArgs, WithTypename<PublishedPost> | string>,
    publishedPosts?: GraphCacheResolver<WithTypename<Query>, QueryPublishedPostsArgs, WithTypename<QueryPublishedPostsConnection> | string>,
    recentReactions?: GraphCacheResolver<WithTypename<Query>, QueryRecentReactionsArgs, Array<WithTypename<GroupedReaction> | string>>,
    recommendedPublications?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<Publication> | string>>,
    sub?: GraphCacheResolver<WithTypename<Query>, QuerySubArgs, WithTypename<Sub> | string>,
    subs?: GraphCacheResolver<WithTypename<Query>, QuerySubsArgs, WithTypename<QuerySubsConnection> | string>,
    tagOptions?: GraphCacheResolver<WithTypename<Query>, QueryTagOptionsArgs, Array<Scalars['String'] | string>>,
    thread?: GraphCacheResolver<WithTypename<Query>, QueryThreadArgs, WithTypename<Thread> | string>,
    unreadThreadCount?: GraphCacheResolver<WithTypename<Query>, QueryUnreadThreadCountArgs, Scalars['Int'] | string>
  },
  BaseError?: {
    message?: GraphCacheResolver<WithTypename<BaseError>, Record<string, never>, Scalars['String'] | string>
  },
  CancelStripeSetupResult?: {
    publication?: GraphCacheResolver<WithTypename<CancelStripeSetupResult>, Record<string, never>, WithTypename<Publication> | string>
  },
  CancelSubscriptionResult?: {
    message?: GraphCacheResolver<WithTypename<CancelSubscriptionResult>, Record<string, never>, Scalars['String'] | string>,
    subscription?: GraphCacheResolver<WithTypename<CancelSubscriptionResult>, Record<string, never>, WithTypename<Sub> | string>,
    success?: GraphCacheResolver<WithTypename<CancelSubscriptionResult>, Record<string, never>, Scalars['Boolean'] | string>
  },
  ContentAccess?: {
    hasAccess?: GraphCacheResolver<WithTypename<ContentAccess>, Record<string, never>, Scalars['Boolean'] | string>,
    reason?: GraphCacheResolver<WithTypename<ContentAccess>, Record<string, never>, Scalars['String'] | string>,
    requiredTiers?: GraphCacheResolver<WithTypename<ContentAccess>, Record<string, never>, Array<WithTypename<SubscriptionTier> | string>>,
    restricted?: GraphCacheResolver<WithTypename<ContentAccess>, Record<string, never>, Scalars['Boolean'] | string>
  },
  CustomerPortalSessionResult?: {
    url?: GraphCacheResolver<WithTypename<CustomerPortalSessionResult>, Record<string, never>, Scalars['String'] | string>
  },
  FeeLevelEntry?: {
    feePercent?: GraphCacheResolver<WithTypename<FeeLevelEntry>, Record<string, never>, Scalars['Int'] | string>,
    threshold?: GraphCacheResolver<WithTypename<FeeLevelEntry>, Record<string, never>, Scalars['Int'] | string>
  },
  FlaggedMessageError?: {
    message?: GraphCacheResolver<WithTypename<FlaggedMessageError>, Record<string, never>, Scalars['String'] | string>
  },
  GroupedReaction?: {
    emojis?: GraphCacheResolver<WithTypename<GroupedReaction>, Record<string, never>, Array<Scalars['String'] | string>>,
    latestReactionAt?: GraphCacheResolver<WithTypename<GroupedReaction>, Record<string, never>, Scalars['DateTime'] | string>,
    latestReactorProfileImage?: GraphCacheResolver<WithTypename<GroupedReaction>, Record<string, never>, Scalars['String'] | string>,
    otherCount?: GraphCacheResolver<WithTypename<GroupedReaction>, Record<string, never>, Scalars['Int'] | string>,
    postId?: GraphCacheResolver<WithTypename<GroupedReaction>, Record<string, never>, Scalars['String'] | string>,
    postTitle?: GraphCacheResolver<WithTypename<GroupedReaction>, Record<string, never>, Scalars['String'] | string>,
    totalCount?: GraphCacheResolver<WithTypename<GroupedReaction>, Record<string, never>, Scalars['Int'] | string>,
    userNames?: GraphCacheResolver<WithTypename<GroupedReaction>, Record<string, never>, Array<Scalars['String'] | string>>
  },
  LeadMagnetFile?: {
    createdAt?: GraphCacheResolver<WithTypename<LeadMagnetFile>, Record<string, never>, Scalars['DateTime'] | string>,
    formId?: GraphCacheResolver<WithTypename<LeadMagnetFile>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<LeadMagnetFile>, Record<string, never>, Scalars['ID'] | string>,
    src?: GraphCacheResolver<WithTypename<LeadMagnetFile>, Record<string, never>, Scalars['String'] | string>,
    title?: GraphCacheResolver<WithTypename<LeadMagnetFile>, Record<string, never>, Scalars['String'] | string>,
    updatedAt?: GraphCacheResolver<WithTypename<LeadMagnetFile>, Record<string, never>, Scalars['DateTime'] | string>
  },
  LeadMagnetForm?: {
    content?: GraphCacheResolver<WithTypename<LeadMagnetForm>, Record<string, never>, Scalars['String'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<LeadMagnetForm>, Record<string, never>, Scalars['DateTime'] | string>,
    emailBody?: GraphCacheResolver<WithTypename<LeadMagnetForm>, Record<string, never>, Scalars['String'] | string>,
    emailSubject?: GraphCacheResolver<WithTypename<LeadMagnetForm>, Record<string, never>, Scalars['String'] | string>,
    files?: GraphCacheResolver<WithTypename<LeadMagnetForm>, Record<string, never>, Array<WithTypename<LeadMagnetFile> | string>>,
    id?: GraphCacheResolver<WithTypename<LeadMagnetForm>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<LeadMagnetForm>, Record<string, never>, Scalars['String'] | string>,
    private?: GraphCacheResolver<WithTypename<LeadMagnetForm>, Record<string, never>, Scalars['Boolean'] | string>,
    subscribersCount?: GraphCacheResolver<WithTypename<LeadMagnetForm>, Record<string, never>, Scalars['Int'] | string>,
    tier?: GraphCacheResolver<WithTypename<LeadMagnetForm>, Record<string, never>, WithTypename<SubscriptionTier> | string>,
    tierId?: GraphCacheResolver<WithTypename<LeadMagnetForm>, Record<string, never>, Scalars['String'] | string>,
    updatedAt?: GraphCacheResolver<WithTypename<LeadMagnetForm>, Record<string, never>, Scalars['DateTime'] | string>
  },
  Me?: {
    authorName?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    bio?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    country?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    currentOnboardingTask?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, WithTypename<OnboardingTask> | string>,
    disabledAt?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['DateTime'] | string>,
    email?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    emailVerified?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['ID'] | string>,
    interestCategories?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    interfaceLocale?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['Locale'] | string>,
    isAdmin?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['Boolean'] | string>,
    onboardingStage?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    profileImage?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    publication?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, WithTypename<Publication> | string>,
    readerOnboarded?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['Boolean'] | string>,
    signupSource?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    socialBandcamp?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    socialBluesky?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    socialBooks?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    socialFacebook?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    socialInstagram?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    socialLinkedin?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    socialSoundcloud?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    socialTiktok?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    socialWebsite?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    socialX?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    socialYoutube?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    title?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    updatedAt?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    username?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['String'] | string>,
    weeklyFeaturedPostsUnsubscribed?: GraphCacheResolver<WithTypename<Me>, Record<string, never>, Scalars['Boolean'] | string>
  },
  Message?: {
    author?: GraphCacheResolver<WithTypename<Message>, Record<string, never>, WithTypename<User> | string>,
    content?: GraphCacheResolver<WithTypename<Message>, Record<string, never>, Scalars['String'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<Message>, Record<string, never>, Scalars['DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<Message>, Record<string, never>, Scalars['ID'] | string>,
    locale?: GraphCacheResolver<WithTypename<Message>, Record<string, never>, Scalars['String'] | string>,
    read?: GraphCacheResolver<WithTypename<Message>, Record<string, never>, Scalars['Boolean'] | string>
  },
  MutationArchivePostSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationArchivePostSuccess>, Record<string, never>, WithTypename<Post> | string>
  },
  MutationCancelStripeSetupSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationCancelStripeSetupSuccess>, Record<string, never>, WithTypename<CancelStripeSetupResult> | string>
  },
  MutationCancelSubscriptionSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationCancelSubscriptionSuccess>, Record<string, never>, WithTypename<CancelSubscriptionResult> | string>
  },
  MutationChangePostMainLocaleSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationChangePostMainLocaleSuccess>, Record<string, never>, WithTypename<Post> | string>
  },
  MutationClaimLeadMagnetFormSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationClaimLeadMagnetFormSuccess>, Record<string, never>, Scalars['Boolean'] | string>
  },
  MutationCreateCustomerPortalSessionSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationCreateCustomerPortalSessionSuccess>, Record<string, never>, WithTypename<CustomerPortalSessionResult> | string>
  },
  MutationCreateNoteSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationCreateNoteSuccess>, Record<string, never>, WithTypename<Note> | string>
  },
  MutationCreatePostSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationCreatePostSuccess>, Record<string, never>, WithTypename<Post> | string>
  },
  MutationCreatePublicationExportSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationCreatePublicationExportSuccess>, Record<string, never>, WithTypename<PublicationExport> | string>
  },
  MutationDeleteCurrentUserSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationDeleteCurrentUserSuccess>, Record<string, never>, Scalars['Boolean'] | string>
  },
  MutationDeleteLeadMagnetFormSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationDeleteLeadMagnetFormSuccess>, Record<string, never>, Scalars['ID'] | string>
  },
  MutationDeleteMessageSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationDeleteMessageSuccess>, Record<string, never>, Scalars['Boolean'] | string>
  },
  MutationDeleteNoteSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationDeleteNoteSuccess>, Record<string, never>, Scalars['Boolean'] | string>
  },
  MutationDeletePostSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationDeletePostSuccess>, Record<string, never>, Scalars['Boolean'] | string>
  },
  MutationGenerateTranslationSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationGenerateTranslationSuccess>, Record<string, never>, WithTypename<Post> | string>
  },
  MutationMarkTranslationAsUpdatedSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationMarkTranslationAsUpdatedSuccess>, Record<string, never>, WithTypename<Post> | string>
  },
  MutationProofreadSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationProofreadSuccess>, Record<string, never>, WithTypename<ProofreadResult> | string>
  },
  MutationPublishPostSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationPublishPostSuccess>, Record<string, never>, WithTypename<Post> | string>
  },
  MutationRestorePostVersionSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationRestorePostVersionSuccess>, Record<string, never>, WithTypename<Post> | string>
  },
  MutationSavePostSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationSavePostSuccess>, Record<string, never>, WithTypename<Post> | string>
  },
  MutationSendMessageSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationSendMessageSuccess>, Record<string, never>, WithTypename<Thread> | string>
  },
  MutationSendTestPostEmailSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationSendTestPostEmailSuccess>, Record<string, never>, Scalars['Boolean'] | string>
  },
  MutationSetTagsSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationSetTagsSuccess>, Record<string, never>, WithTypename<Tags> | string>
  },
  MutationSetTranslationsSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationSetTranslationsSuccess>, Record<string, never>, WithTypename<Post> | string>
  },
  MutationSetUserBannedSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationSetUserBannedSuccess>, Record<string, never>, Scalars['Boolean'] | string>
  },
  MutationSkipOnboardingTaskSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationSkipOnboardingTaskSuccess>, Record<string, never>, WithTypename<OnboardingTask> | string>
  },
  MutationSubscribeToSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationSubscribeToSuccess>, Record<string, never>, WithTypename<User> | string>
  },
  MutationTranslateFieldsSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationTranslateFieldsSuccess>, Record<string, never>, WithTypename<TranslateFieldsResult> | string>
  },
  MutationTranslateMessageSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationTranslateMessageSuccess>, Record<string, never>, WithTypename<TranslateMessageResult> | string>
  },
  MutationUnlinkStripeAccountSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationUnlinkStripeAccountSuccess>, Record<string, never>, WithTypename<UnlinkStripeAccountResult> | string>
  },
  MutationUnsubscribeFromSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationUnsubscribeFromSuccess>, Record<string, never>, WithTypename<Sub> | string>
  },
  MutationUpdateCurrentPublicationSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationUpdateCurrentPublicationSuccess>, Record<string, never>, WithTypename<Publication> | string>
  },
  MutationUpdateCurrentUserSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationUpdateCurrentUserSuccess>, Record<string, never>, WithTypename<Me> | string>
  },
  MutationUpdateNoteSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationUpdateNoteSuccess>, Record<string, never>, WithTypename<Note> | string>
  },
  MutationUpdateOptOutFeaturedPostsSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationUpdateOptOutFeaturedPostsSuccess>, Record<string, never>, WithTypename<Publication> | string>
  },
  MutationUpdatePostSettingsSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationUpdatePostSettingsSuccess>, Record<string, never>, WithTypename<Post> | string>
  },
  MutationUpdatePostTranslationsSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationUpdatePostTranslationsSuccess>, Record<string, never>, WithTypename<Post> | string>
  },
  MutationUpdateReactionEmojisSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationUpdateReactionEmojisSuccess>, Record<string, never>, WithTypename<Publication> | string>
  },
  MutationUpdateWelcomeEmailSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationUpdateWelcomeEmailSuccess>, Record<string, never>, WithTypename<Publication> | string>
  },
  MutationUpsertLeadMagnetFormSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationUpsertLeadMagnetFormSuccess>, Record<string, never>, WithTypename<LeadMagnetForm> | string>
  },
  MutationUpsertPublicationSuccess?: {
    data?: GraphCacheResolver<WithTypename<MutationUpsertPublicationSuccess>, Record<string, never>, WithTypename<Me> | string>
  },
  NotFoundError?: {
    message?: GraphCacheResolver<WithTypename<NotFoundError>, Record<string, never>, Scalars['String'] | string>
  },
  Note?: {
    content?: GraphCacheResolver<WithTypename<Note>, Record<string, never>, Scalars['String'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<Note>, Record<string, never>, Scalars['DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<Note>, Record<string, never>, Scalars['ID'] | string>,
    posts?: GraphCacheResolver<WithTypename<Note>, Record<string, never>, Array<WithTypename<Post> | string>>,
    suggestedTags?: GraphCacheResolver<WithTypename<Note>, Record<string, never>, Array<Scalars['String'] | string>>,
    tags?: GraphCacheResolver<WithTypename<Note>, Record<string, never>, WithTypename<Tags> | string>,
    type?: GraphCacheResolver<WithTypename<Note>, Record<string, never>, NoteTypeEnum | string>,
    updatedAt?: GraphCacheResolver<WithTypename<Note>, Record<string, never>, Scalars['DateTime'] | string>
  },
  OEmbedData?: {
    embedHeight?: GraphCacheResolver<WithTypename<OEmbedData>, Record<string, never>, Scalars['Int'] | string>,
    embedHtml?: GraphCacheResolver<WithTypename<OEmbedData>, Record<string, never>, Scalars['String'] | string>,
    embedUrl?: GraphCacheResolver<WithTypename<OEmbedData>, Record<string, never>, Scalars['String'] | string>,
    embedWidth?: GraphCacheResolver<WithTypename<OEmbedData>, Record<string, never>, Scalars['Int'] | string>,
    providerName?: GraphCacheResolver<WithTypename<OEmbedData>, Record<string, never>, Scalars['String'] | string>,
    thumbnailHeight?: GraphCacheResolver<WithTypename<OEmbedData>, Record<string, never>, Scalars['Int'] | string>,
    thumbnailUrl?: GraphCacheResolver<WithTypename<OEmbedData>, Record<string, never>, Scalars['String'] | string>,
    thumbnailWidth?: GraphCacheResolver<WithTypename<OEmbedData>, Record<string, never>, Scalars['Int'] | string>,
    type?: GraphCacheResolver<WithTypename<OEmbedData>, Record<string, never>, Scalars['String'] | string>
  },
  OEmbedMetadata?: {
    description?: GraphCacheResolver<WithTypename<OEmbedMetadata>, Record<string, never>, Scalars['String'] | string>,
    faviconUrl?: GraphCacheResolver<WithTypename<OEmbedMetadata>, Record<string, never>, Scalars['String'] | string>,
    imageUrl?: GraphCacheResolver<WithTypename<OEmbedMetadata>, Record<string, never>, Scalars['String'] | string>,
    title?: GraphCacheResolver<WithTypename<OEmbedMetadata>, Record<string, never>, Scalars['String'] | string>
  },
  OEmbedResult?: {
    metadata?: GraphCacheResolver<WithTypename<OEmbedResult>, Record<string, never>, WithTypename<OEmbedMetadata> | string>,
    oembed?: GraphCacheResolver<WithTypename<OEmbedResult>, Record<string, never>, WithTypename<OEmbedData> | string>,
    url?: GraphCacheResolver<WithTypename<OEmbedResult>, Record<string, never>, Scalars['String'] | string>
  },
  OnboardingTask?: {
    id?: GraphCacheResolver<WithTypename<OnboardingTask>, Record<string, never>, OnboardingTaskKey | string>,
    status?: GraphCacheResolver<WithTypename<OnboardingTask>, Record<string, never>, OnboardingTaskStatus | string>
  },
  PageInfo?: {
    endCursor?: GraphCacheResolver<WithTypename<PageInfo>, Record<string, never>, Scalars['String'] | string>,
    hasNextPage?: GraphCacheResolver<WithTypename<PageInfo>, Record<string, never>, Scalars['Boolean'] | string>,
    hasPreviousPage?: GraphCacheResolver<WithTypename<PageInfo>, Record<string, never>, Scalars['Boolean'] | string>,
    startCursor?: GraphCacheResolver<WithTypename<PageInfo>, Record<string, never>, Scalars['String'] | string>
  },
  Post?: {
    archivedAt?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['DateTime'] | string>,
    availableLocales?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Array<Scalars['Locale'] | string>>,
    canonicalUrl?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['String'] | string>,
    commentsEnabled?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['Boolean'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['DateTime'] | string>,
    currentVersion?: GraphCacheResolver<WithTypename<Post>, PostCurrentVersionArgs, WithTypename<PostVersion> | string>,
    currentVersions?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Array<WithTypename<PostVersion> | string>>,
    firstPublishedAt?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['DateTime'] | string>,
    form?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, WithTypename<LeadMagnetForm> | string>,
    formId?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['String'] | string>,
    humanContent?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['ID'] | string>,
    mainLocale?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['Locale'] | string>,
    metaDescription?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['String'] | string>,
    metaTitle?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['String'] | string>,
    pinnedAt?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['DateTime'] | string>,
    private?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['Boolean'] | string>,
    publication?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, WithTypename<Publication> | string>,
    publishedAt?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['DateTime'] | string>,
    publishedVersion?: GraphCacheResolver<WithTypename<Post>, PostPublishedVersionArgs, WithTypename<PostVersion> | string>,
    publishedVersions?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Array<WithTypename<PostVersion> | string>>,
    reactions?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Array<WithTypename<ReactionSummary> | string>>,
    relatedNotes?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Array<WithTypename<Note> | string>>,
    sentAt?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['DateTime'] | string>,
    spamScore?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['Int'] | string>,
    stat?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, WithTypename<PostStat> | string>,
    subscriberCount?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['Int'] | string>,
    suggestedTags?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Array<Scalars['String'] | string>>,
    tags?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, WithTypename<Tags> | string>,
    tiers?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Array<WithTypename<SubscriptionTier> | string>>,
    updatedAt?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['DateTime'] | string>,
    url?: GraphCacheResolver<WithTypename<Post>, PostUrlArgs, Scalars['String'] | string>,
    usedProofreaderAt?: GraphCacheResolver<WithTypename<Post>, Record<string, never>, Scalars['DateTime'] | string>,
    versions?: GraphCacheResolver<WithTypename<Post>, PostVersionsArgs, WithTypename<PostVersionsConnection> | string>
  },
  PostHighlight?: {
    content?: GraphCacheResolver<WithTypename<PostHighlight>, Record<string, never>, Scalars['String'] | string>,
    description?: GraphCacheResolver<WithTypename<PostHighlight>, Record<string, never>, Scalars['String'] | string>,
    title?: GraphCacheResolver<WithTypename<PostHighlight>, Record<string, never>, Scalars['String'] | string>
  },
  PostSearch?: {
    highlight?: GraphCacheResolver<WithTypename<PostSearch>, Record<string, never>, WithTypename<PostHighlight> | string>,
    id?: GraphCacheResolver<WithTypename<PostSearch>, Record<string, never>, Scalars['ID'] | string>,
    post?: GraphCacheResolver<WithTypename<PostSearch>, Record<string, never>, WithTypename<Post> | string>,
    rank?: GraphCacheResolver<WithTypename<PostSearch>, Record<string, never>, Scalars['Float'] | string>
  },
  PostStat?: {
    id?: GraphCacheResolver<WithTypename<PostStat>, Record<string, never>, Scalars['ID'] | string>,
    openRatePercent?: GraphCacheResolver<WithTypename<PostStat>, Record<string, never>, Scalars['Float'] | string>,
    recentViews?: GraphCacheResolver<WithTypename<PostStat>, Record<string, never>, Scalars['Int'] | string>
  },
  PostStatsItem?: {
    amount?: GraphCacheResolver<WithTypename<PostStatsItem>, Record<string, never>, Scalars['Int'] | string>,
    day?: GraphCacheResolver<WithTypename<PostStatsItem>, Record<string, never>, Scalars['String'] | string>
  },
  PostVersion?: {
    content?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['String'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['String'] | string>,
    description?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['ID'] | string>,
    imageHeaderUrl?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['String'] | string>,
    locale?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['Locale'] | string>,
    metaDescription?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['String'] | string>,
    metaTitle?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['String'] | string>,
    postId?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['String'] | string>,
    published?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['Boolean'] | string>,
    sent?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['Boolean'] | string>,
    socialImageUrl?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['String'] | string>,
    socialImageUrls?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, WithTypename<SocialImageUrls> | string>,
    title?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['String'] | string>,
    translated?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['Boolean'] | string>,
    translatedContent?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['String'] | string>,
    translatedDescription?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['String'] | string>,
    translatedTitle?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['String'] | string>,
    updatedAt?: GraphCacheResolver<WithTypename<PostVersion>, Record<string, never>, Scalars['DateTime'] | string>
  },
  PostVersionsConnection?: {
    edges?: GraphCacheResolver<WithTypename<PostVersionsConnection>, Record<string, never>, Array<WithTypename<PostVersionsConnectionEdge> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<PostVersionsConnection>, Record<string, never>, WithTypename<PageInfo> | string>
  },
  PostVersionsConnectionEdge?: {
    cursor?: GraphCacheResolver<WithTypename<PostVersionsConnectionEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<PostVersionsConnectionEdge>, Record<string, never>, WithTypename<PostVersion> | string>
  },
  ProofreadResult?: {
    text?: GraphCacheResolver<WithTypename<ProofreadResult>, Record<string, never>, Scalars['String'] | string>
  },
  Publication?: {
    additionalLanguages?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Array<Scalars['Locale'] | string>>,
    author?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, WithTypename<User> | string>,
    blogFooter?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['String'] | string>,
    blogHeader?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['String'] | string>,
    channelStats?: GraphCacheResolver<WithTypename<Publication>, PublicationChannelStatsArgs, Array<WithTypename<TableStatsItem> | string>>,
    countryStats?: GraphCacheResolver<WithTypename<Publication>, PublicationCountryStatsArgs, Array<WithTypename<TableStatsItem> | string>>,
    currentFeePercent?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['Int'] | string>,
    dailyViews?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Array<WithTypename<PostStatsItem> | string>>,
    description?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['String'] | string>,
    enableMonetization?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['Boolean'] | string>,
    faviconUrl?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['String'] | string>,
    feeLevels?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Array<WithTypename<FeeLevelEntry> | string>>,
    id?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['ID'] | string>,
    leadMagnetForms?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Array<WithTypename<LeadMagnetForm> | string>>,
    locale?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['Locale'] | string>,
    logoUrl?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['String'] | string>,
    nameChangeCooldownDays?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['Int'] | string>,
    openRatesStats?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, WithTypename<PublicationOpenRatesStats> | string>,
    optOutFeaturedPosts?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['Boolean'] | string>,
    paidSubscribersCount?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['Int'] | string>,
    publisherId?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['String'] | string>,
    reactionEmojis?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['String'] | string>,
    referrerStats?: GraphCacheResolver<WithTypename<Publication>, PublicationReferrerStatsArgs, Array<WithTypename<TableStatsItem> | string>>,
    stripe?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, WithTypename<Stripe> | string>,
    sub?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, WithTypename<Sub> | string>,
    subscriberStats?: GraphCacheResolver<WithTypename<Publication>, PublicationSubscriberStatsArgs, Array<WithTypename<PostStatsItem> | string>>,
    subscribers?: GraphCacheResolver<WithTypename<Publication>, PublicationSubscribersArgs, WithTypename<PublicationSubscribersConnection> | string>,
    subscribersCount?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['Int'] | string>,
    subscriptionTiers?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Array<WithTypename<SubscriptionTier> | string>>,
    title?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['String'] | string>,
    updatedAt?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['DateTime'] | string>,
    url?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['String'] | string>,
    viewStats?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, WithTypename<PublicationViewStats> | string>,
    welcomeEmailContent?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['String'] | string>,
    welcomeEmailSubject?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['String'] | string>,
    welcomeImageUrl?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['String'] | string>,
    wordmarkUrl?: GraphCacheResolver<WithTypename<Publication>, Record<string, never>, Scalars['String'] | string>
  },
  PublicationExport?: {
    completedAt?: GraphCacheResolver<WithTypename<PublicationExport>, Record<string, never>, Scalars['DateTime'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<PublicationExport>, Record<string, never>, Scalars['DateTime'] | string>,
    error?: GraphCacheResolver<WithTypename<PublicationExport>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<PublicationExport>, Record<string, never>, Scalars['ID'] | string>,
    numPosts?: GraphCacheResolver<WithTypename<PublicationExport>, Record<string, never>, Scalars['Int'] | string>,
    numSubscribers?: GraphCacheResolver<WithTypename<PublicationExport>, Record<string, never>, Scalars['Int'] | string>,
    publicationId?: GraphCacheResolver<WithTypename<PublicationExport>, Record<string, never>, Scalars['String'] | string>
  },
  PublicationOpenRatesStats?: {
    currentMonthEmailsSent?: GraphCacheResolver<WithTypename<PublicationOpenRatesStats>, Record<string, never>, Scalars['Int'] | string>,
    currentMonthOpenRatePercent?: GraphCacheResolver<WithTypename<PublicationOpenRatesStats>, Record<string, never>, Scalars['Float'] | string>,
    previousMonthEmailsSent?: GraphCacheResolver<WithTypename<PublicationOpenRatesStats>, Record<string, never>, Scalars['Int'] | string>,
    previousMonthOpenRatePercent?: GraphCacheResolver<WithTypename<PublicationOpenRatesStats>, Record<string, never>, Scalars['Float'] | string>
  },
  PublicationSubscribersConnection?: {
    edges?: GraphCacheResolver<WithTypename<PublicationSubscribersConnection>, Record<string, never>, Array<WithTypename<PublicationSubscribersConnectionEdge> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<PublicationSubscribersConnection>, Record<string, never>, WithTypename<PageInfo> | string>
  },
  PublicationSubscribersConnectionEdge?: {
    cursor?: GraphCacheResolver<WithTypename<PublicationSubscribersConnectionEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<PublicationSubscribersConnectionEdge>, Record<string, never>, WithTypename<Subscriber> | string>
  },
  PublicationViewStats?: {
    change?: GraphCacheResolver<WithTypename<PublicationViewStats>, Record<string, never>, Scalars['Int'] | string>,
    currentPeriodViews?: GraphCacheResolver<WithTypename<PublicationViewStats>, Record<string, never>, Scalars['Int'] | string>,
    percentChange?: GraphCacheResolver<WithTypename<PublicationViewStats>, Record<string, never>, Scalars['Float'] | string>,
    previousPeriodViews?: GraphCacheResolver<WithTypename<PublicationViewStats>, Record<string, never>, Scalars['Int'] | string>
  },
  PublishedPost?: {
    comments?: GraphCacheResolver<WithTypename<PublishedPost>, Record<string, never>, Array<WithTypename<Thread> | string>>,
    commentsEnabled?: GraphCacheResolver<WithTypename<PublishedPost>, Record<string, never>, Scalars['Boolean'] | string>,
    content?: GraphCacheResolver<WithTypename<PublishedPost>, Record<string, never>, Scalars['String'] | string>,
    contentAccess?: GraphCacheResolver<WithTypename<PublishedPost>, Record<string, never>, WithTypename<ContentAccess> | string>,
    description?: GraphCacheResolver<WithTypename<PublishedPost>, Record<string, never>, Scalars['String'] | string>,
    featuredAt?: GraphCacheResolver<WithTypename<PublishedPost>, Record<string, never>, Scalars['DateTime'] | string>,
    firstPublishedAt?: GraphCacheResolver<WithTypename<PublishedPost>, Record<string, never>, Scalars['DateTime'] | string>,
    humanContent?: GraphCacheResolver<WithTypename<PublishedPost>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<PublishedPost>, Record<string, never>, Scalars['ID'] | string>,
    imageUrl?: GraphCacheResolver<WithTypename<PublishedPost>, Record<string, never>, Scalars['String'] | string>,
    publication?: GraphCacheResolver<WithTypename<PublishedPost>, Record<string, never>, WithTypename<Publication> | string>,
    reactions?: GraphCacheResolver<WithTypename<PublishedPost>, Record<string, never>, Array<WithTypename<ReactionSummary> | string>>,
    title?: GraphCacheResolver<WithTypename<PublishedPost>, Record<string, never>, Scalars['String'] | string>,
    url?: GraphCacheResolver<WithTypename<PublishedPost>, Record<string, never>, Scalars['String'] | string>
  },
  QueryLatestPostNotesConnection?: {
    edges?: GraphCacheResolver<WithTypename<QueryLatestPostNotesConnection>, Record<string, never>, Array<WithTypename<QueryLatestPostNotesConnectionEdge> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<QueryLatestPostNotesConnection>, Record<string, never>, WithTypename<PageInfo> | string>
  },
  QueryLatestPostNotesConnectionEdge?: {
    cursor?: GraphCacheResolver<WithTypename<QueryLatestPostNotesConnectionEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<QueryLatestPostNotesConnectionEdge>, Record<string, never>, WithTypename<Note> | string>
  },
  QueryPostsConnection?: {
    edges?: GraphCacheResolver<WithTypename<QueryPostsConnection>, Record<string, never>, Array<WithTypename<QueryPostsConnectionEdge> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<QueryPostsConnection>, Record<string, never>, WithTypename<PageInfo> | string>
  },
  QueryPostsConnectionEdge?: {
    cursor?: GraphCacheResolver<WithTypename<QueryPostsConnectionEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<QueryPostsConnectionEdge>, Record<string, never>, WithTypename<PostSearch> | string>
  },
  QueryPublishedPostsConnection?: {
    edges?: GraphCacheResolver<WithTypename<QueryPublishedPostsConnection>, Record<string, never>, Array<WithTypename<QueryPublishedPostsConnectionEdge> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<QueryPublishedPostsConnection>, Record<string, never>, WithTypename<PageInfo> | string>
  },
  QueryPublishedPostsConnectionEdge?: {
    cursor?: GraphCacheResolver<WithTypename<QueryPublishedPostsConnectionEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<QueryPublishedPostsConnectionEdge>, Record<string, never>, WithTypename<PublishedPost> | string>
  },
  QuerySubsConnection?: {
    edges?: GraphCacheResolver<WithTypename<QuerySubsConnection>, Record<string, never>, Array<WithTypename<QuerySubsConnectionEdge> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<QuerySubsConnection>, Record<string, never>, WithTypename<PageInfo> | string>
  },
  QuerySubsConnectionEdge?: {
    cursor?: GraphCacheResolver<WithTypename<QuerySubsConnectionEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<QuerySubsConnectionEdge>, Record<string, never>, WithTypename<Sub> | string>
  },
  ReactionSummary?: {
    count?: GraphCacheResolver<WithTypename<ReactionSummary>, Record<string, never>, Scalars['Int'] | string>,
    emoji?: GraphCacheResolver<WithTypename<ReactionSummary>, Record<string, never>, Scalars['String'] | string>,
    reacted?: GraphCacheResolver<WithTypename<ReactionSummary>, Record<string, never>, Scalars['Boolean'] | string>
  },
  SocialImageUrls?: {
    landscape?: GraphCacheResolver<WithTypename<SocialImageUrls>, Record<string, never>, Scalars['String'] | string>,
    portrait?: GraphCacheResolver<WithTypename<SocialImageUrls>, Record<string, never>, Scalars['String'] | string>,
    square?: GraphCacheResolver<WithTypename<SocialImageUrls>, Record<string, never>, Scalars['String'] | string>,
    story?: GraphCacheResolver<WithTypename<SocialImageUrls>, Record<string, never>, Scalars['String'] | string>
  },
  Stripe?: {
    accountId?: GraphCacheResolver<WithTypename<Stripe>, Record<string, never>, Scalars['String'] | string>,
    businessName?: GraphCacheResolver<WithTypename<Stripe>, Record<string, never>, Scalars['String'] | string>,
    companyName?: GraphCacheResolver<WithTypename<Stripe>, Record<string, never>, Scalars['String'] | string>,
    dashboardUrl?: GraphCacheResolver<WithTypename<Stripe>, Record<string, never>, Scalars['String'] | string>,
    iconUrl?: GraphCacheResolver<WithTypename<Stripe>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Stripe>, Record<string, never>, Scalars['String'] | string>,
    setupComplete?: GraphCacheResolver<WithTypename<Stripe>, Record<string, never>, Scalars['Boolean'] | string>
  },
  StripePrice?: {
    currency?: GraphCacheResolver<WithTypename<StripePrice>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<StripePrice>, Record<string, never>, Scalars['String'] | string>,
    interval?: GraphCacheResolver<WithTypename<StripePrice>, Record<string, never>, Scalars['String'] | string>,
    unitAmount?: GraphCacheResolver<WithTypename<StripePrice>, Record<string, never>, Scalars['Int'] | string>
  },
  Sub?: {
    billingInterval?: GraphCacheResolver<WithTypename<Sub>, Record<string, never>, Scalars['String'] | string>,
    currentPeriodEnd?: GraphCacheResolver<WithTypename<Sub>, Record<string, never>, Scalars['DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<Sub>, Record<string, never>, Scalars['ID'] | string>,
    post?: GraphCacheResolver<WithTypename<Sub>, Record<string, never>, WithTypename<Post> | string>,
    publication?: GraphCacheResolver<WithTypename<Sub>, Record<string, never>, WithTypename<Publication> | string>,
    stripeSubscriptionId?: GraphCacheResolver<WithTypename<Sub>, Record<string, never>, Scalars['String'] | string>,
    subscribedAt?: GraphCacheResolver<WithTypename<Sub>, Record<string, never>, Scalars['DateTime'] | string>,
    tier?: GraphCacheResolver<WithTypename<Sub>, Record<string, never>, WithTypename<SubscriptionTier> | string>
  },
  Subscriber?: {
    email?: GraphCacheResolver<WithTypename<Subscriber>, Record<string, never>, Scalars['String'] | string>,
    form?: GraphCacheResolver<WithTypename<Subscriber>, Record<string, never>, WithTypename<LeadMagnetForm> | string>,
    formName?: GraphCacheResolver<WithTypename<Subscriber>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Subscriber>, Record<string, never>, Scalars['ID'] | string>,
    searchResult?: GraphCacheResolver<WithTypename<Subscriber>, Record<string, never>, WithTypename<SubscriberSearchResult> | string>,
    subscribedAt?: GraphCacheResolver<WithTypename<Subscriber>, Record<string, never>, Scalars['DateTime'] | string>,
    tier?: GraphCacheResolver<WithTypename<Subscriber>, Record<string, never>, WithTypename<SubscriptionTier> | string>,
    user?: GraphCacheResolver<WithTypename<Subscriber>, Record<string, never>, WithTypename<User> | string>
  },
  SubscriberHighlight?: {
    email?: GraphCacheResolver<WithTypename<SubscriberHighlight>, Record<string, never>, Scalars['String'] | string>
  },
  SubscriberSearchResult?: {
    highlight?: GraphCacheResolver<WithTypename<SubscriberSearchResult>, Record<string, never>, WithTypename<SubscriberHighlight> | string>,
    rank?: GraphCacheResolver<WithTypename<SubscriberSearchResult>, Record<string, never>, Scalars['Float'] | string>
  },
  SubscriptionTier?: {
    annualPriceCents?: GraphCacheResolver<WithTypename<SubscriptionTier>, Record<string, never>, Scalars['Int'] | string>,
    canPurchase?: GraphCacheResolver<WithTypename<SubscriptionTier>, Record<string, never>, Scalars['Boolean'] | string>,
    description?: GraphCacheResolver<WithTypename<SubscriptionTier>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<SubscriptionTier>, Record<string, never>, Scalars['ID'] | string>,
    monthlyPriceCents?: GraphCacheResolver<WithTypename<SubscriptionTier>, Record<string, never>, Scalars['Int'] | string>,
    name?: GraphCacheResolver<WithTypename<SubscriptionTier>, Record<string, never>, Scalars['String'] | string>,
    publication?: GraphCacheResolver<WithTypename<SubscriptionTier>, Record<string, never>, WithTypename<Publication> | string>,
    stripeAnnualPriceId?: GraphCacheResolver<WithTypename<SubscriptionTier>, Record<string, never>, Scalars['String'] | string>,
    stripeMonthlyPriceId?: GraphCacheResolver<WithTypename<SubscriptionTier>, Record<string, never>, Scalars['String'] | string>,
    stripeProductId?: GraphCacheResolver<WithTypename<SubscriptionTier>, Record<string, never>, Scalars['String'] | string>,
    subscriberCount?: GraphCacheResolver<WithTypename<SubscriptionTier>, Record<string, never>, Scalars['Int'] | string>
  },
  TableStatsItem?: {
    label?: GraphCacheResolver<WithTypename<TableStatsItem>, Record<string, never>, Scalars['String'] | string>,
    pageviews?: GraphCacheResolver<WithTypename<TableStatsItem>, Record<string, never>, Scalars['Int'] | string>,
    visitors?: GraphCacheResolver<WithTypename<TableStatsItem>, Record<string, never>, Scalars['Int'] | string>
  },
  Tags?: {
    id?: GraphCacheResolver<WithTypename<Tags>, Record<string, never>, Scalars['ID'] | string>,
    tags?: GraphCacheResolver<WithTypename<Tags>, Record<string, never>, Array<Scalars['String'] | string>>
  },
  Thread?: {
    createdAt?: GraphCacheResolver<WithTypename<Thread>, Record<string, never>, Scalars['DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<Thread>, Record<string, never>, Scalars['ID'] | string>,
    lastMessage?: GraphCacheResolver<WithTypename<Thread>, Record<string, never>, WithTypename<Message> | string>,
    messages?: GraphCacheResolver<WithTypename<Thread>, Record<string, never>, Array<WithTypename<Message> | string>>,
    participantCount?: GraphCacheResolver<WithTypename<Thread>, Record<string, never>, Scalars['Int'] | string>,
    participants?: GraphCacheResolver<WithTypename<Thread>, Record<string, never>, Array<WithTypename<User> | string>>,
    post?: GraphCacheResolver<WithTypename<Thread>, Record<string, never>, WithTypename<PublishedPost> | string>,
    postId?: GraphCacheResolver<WithTypename<Thread>, Record<string, never>, Scalars['String'] | string>,
    private?: GraphCacheResolver<WithTypename<Thread>, Record<string, never>, Scalars['Boolean'] | string>,
    subject?: GraphCacheResolver<WithTypename<Thread>, Record<string, never>, Scalars['String'] | string>,
    unreadCount?: GraphCacheResolver<WithTypename<Thread>, Record<string, never>, Scalars['Int'] | string>,
    updatedAt?: GraphCacheResolver<WithTypename<Thread>, Record<string, never>, Scalars['DateTime'] | string>
  },
  TranslateFieldsResult?: {
    results?: GraphCacheResolver<WithTypename<TranslateFieldsResult>, Record<string, never>, Scalars['String'] | string>
  },
  TranslateMessageResult?: {
    renderedContent?: GraphCacheResolver<WithTypename<TranslateMessageResult>, Record<string, never>, Scalars['String'] | string>,
    translatedContent?: GraphCacheResolver<WithTypename<TranslateMessageResult>, Record<string, never>, Scalars['String'] | string>
  },
  UnauthorizedError?: {
    message?: GraphCacheResolver<WithTypename<UnauthorizedError>, Record<string, never>, Scalars['String'] | string>
  },
  UnlinkStripeAccountResult?: {
    publication?: GraphCacheResolver<WithTypename<UnlinkStripeAccountResult>, Record<string, never>, WithTypename<Publication> | string>
  },
  User?: {
    authorName?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    bio?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    displayName?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    email?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    followsYou?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['ID'] | string>,
    isMe?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Boolean'] | string>,
    profileImage?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    publication?: GraphCacheResolver<WithTypename<User>, Record<string, never>, WithTypename<Publication> | string>,
    publicationUrl?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    socialBandcamp?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    socialBluesky?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    socialBooks?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    socialFacebook?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    socialInstagram?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    socialLinkedin?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    socialSoundcloud?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    socialTiktok?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    socialWebsite?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    socialX?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    socialYoutube?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    title?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    updatedAt?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    username?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>
  },
  ValidationError?: {
    message?: GraphCacheResolver<WithTypename<ValidationError>, Record<string, never>, Scalars['String'] | string>
  }
};

export type GraphCacheOptimisticUpdaters = {
  archivePost?: GraphCacheOptimisticMutationResolver<MutationArchivePostArgs, WithTypename<MutationArchivePostResult>>,
  cancelStripeSetup?: GraphCacheOptimisticMutationResolver<MutationCancelStripeSetupArgs, WithTypename<MutationCancelStripeSetupResult>>,
  cancelSubscription?: GraphCacheOptimisticMutationResolver<MutationCancelSubscriptionArgs, WithTypename<MutationCancelSubscriptionResult>>,
  changePostMainLocale?: GraphCacheOptimisticMutationResolver<MutationChangePostMainLocaleArgs, WithTypename<MutationChangePostMainLocaleResult>>,
  claimLeadMagnetForm?: GraphCacheOptimisticMutationResolver<MutationClaimLeadMagnetFormArgs, WithTypename<MutationClaimLeadMagnetFormResult>>,
  createCustomerPortalSession?: GraphCacheOptimisticMutationResolver<MutationCreateCustomerPortalSessionArgs, WithTypename<MutationCreateCustomerPortalSessionResult>>,
  createNote?: GraphCacheOptimisticMutationResolver<MutationCreateNoteArgs, WithTypename<MutationCreateNoteResult>>,
  createPost?: GraphCacheOptimisticMutationResolver<MutationCreatePostArgs, WithTypename<MutationCreatePostResult>>,
  createPublicationExport?: GraphCacheOptimisticMutationResolver<Record<string, never>, WithTypename<MutationCreatePublicationExportResult>>,
  deleteCurrentUser?: GraphCacheOptimisticMutationResolver<Record<string, never>, WithTypename<MutationDeleteCurrentUserResult>>,
  deleteLeadMagnetForm?: GraphCacheOptimisticMutationResolver<MutationDeleteLeadMagnetFormArgs, WithTypename<MutationDeleteLeadMagnetFormResult>>,
  deleteMessage?: GraphCacheOptimisticMutationResolver<MutationDeleteMessageArgs, WithTypename<MutationDeleteMessageResult>>,
  deleteNote?: GraphCacheOptimisticMutationResolver<MutationDeleteNoteArgs, WithTypename<MutationDeleteNoteResult>>,
  deletePost?: GraphCacheOptimisticMutationResolver<MutationDeletePostArgs, WithTypename<MutationDeletePostResult>>,
  generateTranslation?: GraphCacheOptimisticMutationResolver<MutationGenerateTranslationArgs, WithTypename<MutationGenerateTranslationResult>>,
  markThreadRead?: GraphCacheOptimisticMutationResolver<MutationMarkThreadReadArgs, Scalars['Boolean']>,
  markTranslationAsUpdated?: GraphCacheOptimisticMutationResolver<MutationMarkTranslationAsUpdatedArgs, WithTypename<MutationMarkTranslationAsUpdatedResult>>,
  proofread?: GraphCacheOptimisticMutationResolver<MutationProofreadArgs, WithTypename<MutationProofreadResult>>,
  publishPost?: GraphCacheOptimisticMutationResolver<MutationPublishPostArgs, WithTypename<MutationPublishPostResult>>,
  restorePostVersion?: GraphCacheOptimisticMutationResolver<MutationRestorePostVersionArgs, WithTypename<MutationRestorePostVersionResult>>,
  savePost?: GraphCacheOptimisticMutationResolver<MutationSavePostArgs, WithTypename<MutationSavePostResult>>,
  sendMessage?: GraphCacheOptimisticMutationResolver<MutationSendMessageArgs, WithTypename<MutationSendMessageResult>>,
  sendTestPostEmail?: GraphCacheOptimisticMutationResolver<MutationSendTestPostEmailArgs, WithTypename<MutationSendTestPostEmailResult>>,
  setTags?: GraphCacheOptimisticMutationResolver<MutationSetTagsArgs, WithTypename<MutationSetTagsResult>>,
  setTranslations?: GraphCacheOptimisticMutationResolver<MutationSetTranslationsArgs, WithTypename<MutationSetTranslationsResult>>,
  setUserBanned?: GraphCacheOptimisticMutationResolver<MutationSetUserBannedArgs, WithTypename<MutationSetUserBannedResult>>,
  skipOnboardingTask?: GraphCacheOptimisticMutationResolver<MutationSkipOnboardingTaskArgs, WithTypename<MutationSkipOnboardingTaskResult>>,
  subscribeTo?: GraphCacheOptimisticMutationResolver<MutationSubscribeToArgs, WithTypename<MutationSubscribeToResult>>,
  toggleReaction?: GraphCacheOptimisticMutationResolver<MutationToggleReactionArgs, WithTypename<PublishedPost>>,
  translateFields?: GraphCacheOptimisticMutationResolver<MutationTranslateFieldsArgs, WithTypename<MutationTranslateFieldsResult>>,
  translateMessage?: GraphCacheOptimisticMutationResolver<MutationTranslateMessageArgs, WithTypename<MutationTranslateMessageResult>>,
  unlinkStripeAccount?: GraphCacheOptimisticMutationResolver<MutationUnlinkStripeAccountArgs, WithTypename<MutationUnlinkStripeAccountResult>>,
  unsubscribeFrom?: GraphCacheOptimisticMutationResolver<MutationUnsubscribeFromArgs, WithTypename<MutationUnsubscribeFromResult>>,
  updateCurrentPublication?: GraphCacheOptimisticMutationResolver<MutationUpdateCurrentPublicationArgs, WithTypename<MutationUpdateCurrentPublicationResult>>,
  updateCurrentUser?: GraphCacheOptimisticMutationResolver<MutationUpdateCurrentUserArgs, WithTypename<MutationUpdateCurrentUserResult>>,
  updateNote?: GraphCacheOptimisticMutationResolver<MutationUpdateNoteArgs, WithTypename<MutationUpdateNoteResult>>,
  updateOptOutFeaturedPosts?: GraphCacheOptimisticMutationResolver<MutationUpdateOptOutFeaturedPostsArgs, WithTypename<MutationUpdateOptOutFeaturedPostsResult>>,
  updatePostSettings?: GraphCacheOptimisticMutationResolver<MutationUpdatePostSettingsArgs, WithTypename<MutationUpdatePostSettingsResult>>,
  updatePostTranslations?: GraphCacheOptimisticMutationResolver<MutationUpdatePostTranslationsArgs, WithTypename<MutationUpdatePostTranslationsResult>>,
  updateReactionEmojis?: GraphCacheOptimisticMutationResolver<MutationUpdateReactionEmojisArgs, WithTypename<MutationUpdateReactionEmojisResult>>,
  updateWelcomeEmail?: GraphCacheOptimisticMutationResolver<MutationUpdateWelcomeEmailArgs, WithTypename<MutationUpdateWelcomeEmailResult>>,
  upsertLeadMagnetForm?: GraphCacheOptimisticMutationResolver<MutationUpsertLeadMagnetFormArgs, WithTypename<MutationUpsertLeadMagnetFormResult>>,
  upsertPublication?: GraphCacheOptimisticMutationResolver<MutationUpsertPublicationArgs, WithTypename<MutationUpsertPublicationResult>>
};

export type GraphCacheUpdaters = {
  Query?: {
    inbox?: GraphCacheUpdateResolver<{ inbox: Array<WithTypename<Thread>> }, QueryInboxArgs>,
    latestPostNotes?: GraphCacheUpdateResolver<{ latestPostNotes: WithTypename<QueryLatestPostNotesConnection> }, QueryLatestPostNotesArgs>,
    me?: GraphCacheUpdateResolver<{ me: Maybe<WithTypename<Me>> }, Record<string, never>>,
    myPublication?: GraphCacheUpdateResolver<{ myPublication: Maybe<WithTypename<Publication>> }, Record<string, never>>,
    oembed?: GraphCacheUpdateResolver<{ oembed: Maybe<WithTypename<OEmbedResult>> }, QueryOembedArgs>,
    onboardingTask?: GraphCacheUpdateResolver<{ onboardingTask: Maybe<WithTypename<OnboardingTask>> }, QueryOnboardingTaskArgs>,
    post?: GraphCacheUpdateResolver<{ post: Maybe<WithTypename<Post>> }, QueryPostArgs>,
    postComments?: GraphCacheUpdateResolver<{ postComments: Array<WithTypename<Thread>> }, QueryPostCommentsArgs>,
    postStats?: GraphCacheUpdateResolver<{ postStats: Array<WithTypename<PostStatsItem>> }, QueryPostStatsArgs>,
    posts?: GraphCacheUpdateResolver<{ posts: WithTypename<QueryPostsConnection> }, QueryPostsArgs>,
    publication?: GraphCacheUpdateResolver<{ publication: Maybe<WithTypename<Publication>> }, QueryPublicationArgs>,
    publicationExports?: GraphCacheUpdateResolver<{ publicationExports: Array<WithTypename<PublicationExport>> }, Record<string, never>>,
    publishedPost?: GraphCacheUpdateResolver<{ publishedPost: Maybe<WithTypename<PublishedPost>> }, QueryPublishedPostArgs>,
    publishedPosts?: GraphCacheUpdateResolver<{ publishedPosts: WithTypename<QueryPublishedPostsConnection> }, QueryPublishedPostsArgs>,
    recentReactions?: GraphCacheUpdateResolver<{ recentReactions: Array<WithTypename<GroupedReaction>> }, QueryRecentReactionsArgs>,
    recommendedPublications?: GraphCacheUpdateResolver<{ recommendedPublications: Array<WithTypename<Publication>> }, Record<string, never>>,
    sub?: GraphCacheUpdateResolver<{ sub: Maybe<WithTypename<Sub>> }, QuerySubArgs>,
    subs?: GraphCacheUpdateResolver<{ subs: WithTypename<QuerySubsConnection> }, QuerySubsArgs>,
    tagOptions?: GraphCacheUpdateResolver<{ tagOptions: Array<Scalars['String']> }, QueryTagOptionsArgs>,
    thread?: GraphCacheUpdateResolver<{ thread: Maybe<WithTypename<Thread>> }, QueryThreadArgs>,
    unreadThreadCount?: GraphCacheUpdateResolver<{ unreadThreadCount: Scalars['Int'] }, QueryUnreadThreadCountArgs>
  },
  Mutation?: {
    archivePost?: GraphCacheUpdateResolver<{ archivePost: WithTypename<MutationArchivePostResult> }, MutationArchivePostArgs>,
    cancelStripeSetup?: GraphCacheUpdateResolver<{ cancelStripeSetup: WithTypename<MutationCancelStripeSetupResult> }, MutationCancelStripeSetupArgs>,
    cancelSubscription?: GraphCacheUpdateResolver<{ cancelSubscription: WithTypename<MutationCancelSubscriptionResult> }, MutationCancelSubscriptionArgs>,
    changePostMainLocale?: GraphCacheUpdateResolver<{ changePostMainLocale: WithTypename<MutationChangePostMainLocaleResult> }, MutationChangePostMainLocaleArgs>,
    claimLeadMagnetForm?: GraphCacheUpdateResolver<{ claimLeadMagnetForm: WithTypename<MutationClaimLeadMagnetFormResult> }, MutationClaimLeadMagnetFormArgs>,
    createCustomerPortalSession?: GraphCacheUpdateResolver<{ createCustomerPortalSession: WithTypename<MutationCreateCustomerPortalSessionResult> }, MutationCreateCustomerPortalSessionArgs>,
    createNote?: GraphCacheUpdateResolver<{ createNote: WithTypename<MutationCreateNoteResult> }, MutationCreateNoteArgs>,
    createPost?: GraphCacheUpdateResolver<{ createPost: WithTypename<MutationCreatePostResult> }, MutationCreatePostArgs>,
    createPublicationExport?: GraphCacheUpdateResolver<{ createPublicationExport: WithTypename<MutationCreatePublicationExportResult> }, Record<string, never>>,
    deleteCurrentUser?: GraphCacheUpdateResolver<{ deleteCurrentUser: WithTypename<MutationDeleteCurrentUserResult> }, Record<string, never>>,
    deleteLeadMagnetForm?: GraphCacheUpdateResolver<{ deleteLeadMagnetForm: WithTypename<MutationDeleteLeadMagnetFormResult> }, MutationDeleteLeadMagnetFormArgs>,
    deleteMessage?: GraphCacheUpdateResolver<{ deleteMessage: WithTypename<MutationDeleteMessageResult> }, MutationDeleteMessageArgs>,
    deleteNote?: GraphCacheUpdateResolver<{ deleteNote: WithTypename<MutationDeleteNoteResult> }, MutationDeleteNoteArgs>,
    deletePost?: GraphCacheUpdateResolver<{ deletePost: WithTypename<MutationDeletePostResult> }, MutationDeletePostArgs>,
    generateTranslation?: GraphCacheUpdateResolver<{ generateTranslation: WithTypename<MutationGenerateTranslationResult> }, MutationGenerateTranslationArgs>,
    markThreadRead?: GraphCacheUpdateResolver<{ markThreadRead: Scalars['Boolean'] }, MutationMarkThreadReadArgs>,
    markTranslationAsUpdated?: GraphCacheUpdateResolver<{ markTranslationAsUpdated: WithTypename<MutationMarkTranslationAsUpdatedResult> }, MutationMarkTranslationAsUpdatedArgs>,
    proofread?: GraphCacheUpdateResolver<{ proofread: WithTypename<MutationProofreadResult> }, MutationProofreadArgs>,
    publishPost?: GraphCacheUpdateResolver<{ publishPost: WithTypename<MutationPublishPostResult> }, MutationPublishPostArgs>,
    restorePostVersion?: GraphCacheUpdateResolver<{ restorePostVersion: WithTypename<MutationRestorePostVersionResult> }, MutationRestorePostVersionArgs>,
    savePost?: GraphCacheUpdateResolver<{ savePost: WithTypename<MutationSavePostResult> }, MutationSavePostArgs>,
    sendMessage?: GraphCacheUpdateResolver<{ sendMessage: WithTypename<MutationSendMessageResult> }, MutationSendMessageArgs>,
    sendTestPostEmail?: GraphCacheUpdateResolver<{ sendTestPostEmail: WithTypename<MutationSendTestPostEmailResult> }, MutationSendTestPostEmailArgs>,
    setTags?: GraphCacheUpdateResolver<{ setTags: WithTypename<MutationSetTagsResult> }, MutationSetTagsArgs>,
    setTranslations?: GraphCacheUpdateResolver<{ setTranslations: WithTypename<MutationSetTranslationsResult> }, MutationSetTranslationsArgs>,
    setUserBanned?: GraphCacheUpdateResolver<{ setUserBanned: WithTypename<MutationSetUserBannedResult> }, MutationSetUserBannedArgs>,
    skipOnboardingTask?: GraphCacheUpdateResolver<{ skipOnboardingTask: WithTypename<MutationSkipOnboardingTaskResult> }, MutationSkipOnboardingTaskArgs>,
    subscribeTo?: GraphCacheUpdateResolver<{ subscribeTo: WithTypename<MutationSubscribeToResult> }, MutationSubscribeToArgs>,
    toggleReaction?: GraphCacheUpdateResolver<{ toggleReaction: WithTypename<PublishedPost> }, MutationToggleReactionArgs>,
    translateFields?: GraphCacheUpdateResolver<{ translateFields: WithTypename<MutationTranslateFieldsResult> }, MutationTranslateFieldsArgs>,
    translateMessage?: GraphCacheUpdateResolver<{ translateMessage: WithTypename<MutationTranslateMessageResult> }, MutationTranslateMessageArgs>,
    unlinkStripeAccount?: GraphCacheUpdateResolver<{ unlinkStripeAccount: WithTypename<MutationUnlinkStripeAccountResult> }, MutationUnlinkStripeAccountArgs>,
    unsubscribeFrom?: GraphCacheUpdateResolver<{ unsubscribeFrom: WithTypename<MutationUnsubscribeFromResult> }, MutationUnsubscribeFromArgs>,
    updateCurrentPublication?: GraphCacheUpdateResolver<{ updateCurrentPublication: WithTypename<MutationUpdateCurrentPublicationResult> }, MutationUpdateCurrentPublicationArgs>,
    updateCurrentUser?: GraphCacheUpdateResolver<{ updateCurrentUser: WithTypename<MutationUpdateCurrentUserResult> }, MutationUpdateCurrentUserArgs>,
    updateNote?: GraphCacheUpdateResolver<{ updateNote: WithTypename<MutationUpdateNoteResult> }, MutationUpdateNoteArgs>,
    updateOptOutFeaturedPosts?: GraphCacheUpdateResolver<{ updateOptOutFeaturedPosts: WithTypename<MutationUpdateOptOutFeaturedPostsResult> }, MutationUpdateOptOutFeaturedPostsArgs>,
    updatePostSettings?: GraphCacheUpdateResolver<{ updatePostSettings: WithTypename<MutationUpdatePostSettingsResult> }, MutationUpdatePostSettingsArgs>,
    updatePostTranslations?: GraphCacheUpdateResolver<{ updatePostTranslations: WithTypename<MutationUpdatePostTranslationsResult> }, MutationUpdatePostTranslationsArgs>,
    updateReactionEmojis?: GraphCacheUpdateResolver<{ updateReactionEmojis: WithTypename<MutationUpdateReactionEmojisResult> }, MutationUpdateReactionEmojisArgs>,
    updateWelcomeEmail?: GraphCacheUpdateResolver<{ updateWelcomeEmail: WithTypename<MutationUpdateWelcomeEmailResult> }, MutationUpdateWelcomeEmailArgs>,
    upsertLeadMagnetForm?: GraphCacheUpdateResolver<{ upsertLeadMagnetForm: WithTypename<MutationUpsertLeadMagnetFormResult> }, MutationUpsertLeadMagnetFormArgs>,
    upsertPublication?: GraphCacheUpdateResolver<{ upsertPublication: WithTypename<MutationUpsertPublicationResult> }, MutationUpsertPublicationArgs>
  },
  Subscription?: {},
  BaseError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseError>>, Record<string, never>>
  },
  CancelStripeSetupResult?: {
    publication?: GraphCacheUpdateResolver<Maybe<WithTypename<CancelStripeSetupResult>>, Record<string, never>>
  },
  CancelSubscriptionResult?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<CancelSubscriptionResult>>, Record<string, never>>,
    subscription?: GraphCacheUpdateResolver<Maybe<WithTypename<CancelSubscriptionResult>>, Record<string, never>>,
    success?: GraphCacheUpdateResolver<Maybe<WithTypename<CancelSubscriptionResult>>, Record<string, never>>
  },
  ContentAccess?: {
    hasAccess?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentAccess>>, Record<string, never>>,
    reason?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentAccess>>, Record<string, never>>,
    requiredTiers?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentAccess>>, Record<string, never>>,
    restricted?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentAccess>>, Record<string, never>>
  },
  CustomerPortalSessionResult?: {
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomerPortalSessionResult>>, Record<string, never>>
  },
  FeeLevelEntry?: {
    feePercent?: GraphCacheUpdateResolver<Maybe<WithTypename<FeeLevelEntry>>, Record<string, never>>,
    threshold?: GraphCacheUpdateResolver<Maybe<WithTypename<FeeLevelEntry>>, Record<string, never>>
  },
  FlaggedMessageError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<FlaggedMessageError>>, Record<string, never>>
  },
  GroupedReaction?: {
    emojis?: GraphCacheUpdateResolver<Maybe<WithTypename<GroupedReaction>>, Record<string, never>>,
    latestReactionAt?: GraphCacheUpdateResolver<Maybe<WithTypename<GroupedReaction>>, Record<string, never>>,
    latestReactorProfileImage?: GraphCacheUpdateResolver<Maybe<WithTypename<GroupedReaction>>, Record<string, never>>,
    otherCount?: GraphCacheUpdateResolver<Maybe<WithTypename<GroupedReaction>>, Record<string, never>>,
    postId?: GraphCacheUpdateResolver<Maybe<WithTypename<GroupedReaction>>, Record<string, never>>,
    postTitle?: GraphCacheUpdateResolver<Maybe<WithTypename<GroupedReaction>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<GroupedReaction>>, Record<string, never>>,
    userNames?: GraphCacheUpdateResolver<Maybe<WithTypename<GroupedReaction>>, Record<string, never>>
  },
  LeadMagnetFile?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetFile>>, Record<string, never>>,
    formId?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetFile>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetFile>>, Record<string, never>>,
    src?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetFile>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetFile>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetFile>>, Record<string, never>>
  },
  LeadMagnetForm?: {
    content?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetForm>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetForm>>, Record<string, never>>,
    emailBody?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetForm>>, Record<string, never>>,
    emailSubject?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetForm>>, Record<string, never>>,
    files?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetForm>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetForm>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetForm>>, Record<string, never>>,
    private?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetForm>>, Record<string, never>>,
    subscribersCount?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetForm>>, Record<string, never>>,
    tier?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetForm>>, Record<string, never>>,
    tierId?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetForm>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<LeadMagnetForm>>, Record<string, never>>
  },
  Me?: {
    authorName?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    bio?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    country?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    currentOnboardingTask?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    disabledAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    email?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    emailVerified?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    interestCategories?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    interfaceLocale?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    isAdmin?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    onboardingStage?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    profileImage?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    publication?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    readerOnboarded?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    signupSource?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    socialBandcamp?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    socialBluesky?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    socialBooks?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    socialFacebook?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    socialInstagram?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    socialLinkedin?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    socialSoundcloud?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    socialTiktok?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    socialWebsite?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    socialX?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    socialYoutube?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    username?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>,
    weeklyFeaturedPostsUnsubscribed?: GraphCacheUpdateResolver<Maybe<WithTypename<Me>>, Record<string, never>>
  },
  Message?: {
    author?: GraphCacheUpdateResolver<Maybe<WithTypename<Message>>, Record<string, never>>,
    content?: GraphCacheUpdateResolver<Maybe<WithTypename<Message>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Message>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Message>>, Record<string, never>>,
    locale?: GraphCacheUpdateResolver<Maybe<WithTypename<Message>>, Record<string, never>>,
    read?: GraphCacheUpdateResolver<Maybe<WithTypename<Message>>, Record<string, never>>
  },
  MutationArchivePostSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationArchivePostSuccess>>, Record<string, never>>
  },
  MutationCancelStripeSetupSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationCancelStripeSetupSuccess>>, Record<string, never>>
  },
  MutationCancelSubscriptionSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationCancelSubscriptionSuccess>>, Record<string, never>>
  },
  MutationChangePostMainLocaleSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationChangePostMainLocaleSuccess>>, Record<string, never>>
  },
  MutationClaimLeadMagnetFormSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationClaimLeadMagnetFormSuccess>>, Record<string, never>>
  },
  MutationCreateCustomerPortalSessionSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationCreateCustomerPortalSessionSuccess>>, Record<string, never>>
  },
  MutationCreateNoteSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationCreateNoteSuccess>>, Record<string, never>>
  },
  MutationCreatePostSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationCreatePostSuccess>>, Record<string, never>>
  },
  MutationCreatePublicationExportSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationCreatePublicationExportSuccess>>, Record<string, never>>
  },
  MutationDeleteCurrentUserSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationDeleteCurrentUserSuccess>>, Record<string, never>>
  },
  MutationDeleteLeadMagnetFormSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationDeleteLeadMagnetFormSuccess>>, Record<string, never>>
  },
  MutationDeleteMessageSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationDeleteMessageSuccess>>, Record<string, never>>
  },
  MutationDeleteNoteSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationDeleteNoteSuccess>>, Record<string, never>>
  },
  MutationDeletePostSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationDeletePostSuccess>>, Record<string, never>>
  },
  MutationGenerateTranslationSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationGenerateTranslationSuccess>>, Record<string, never>>
  },
  MutationMarkTranslationAsUpdatedSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationMarkTranslationAsUpdatedSuccess>>, Record<string, never>>
  },
  MutationProofreadSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationProofreadSuccess>>, Record<string, never>>
  },
  MutationPublishPostSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationPublishPostSuccess>>, Record<string, never>>
  },
  MutationRestorePostVersionSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationRestorePostVersionSuccess>>, Record<string, never>>
  },
  MutationSavePostSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationSavePostSuccess>>, Record<string, never>>
  },
  MutationSendMessageSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationSendMessageSuccess>>, Record<string, never>>
  },
  MutationSendTestPostEmailSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationSendTestPostEmailSuccess>>, Record<string, never>>
  },
  MutationSetTagsSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationSetTagsSuccess>>, Record<string, never>>
  },
  MutationSetTranslationsSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationSetTranslationsSuccess>>, Record<string, never>>
  },
  MutationSetUserBannedSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationSetUserBannedSuccess>>, Record<string, never>>
  },
  MutationSkipOnboardingTaskSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationSkipOnboardingTaskSuccess>>, Record<string, never>>
  },
  MutationSubscribeToSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationSubscribeToSuccess>>, Record<string, never>>
  },
  MutationTranslateFieldsSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationTranslateFieldsSuccess>>, Record<string, never>>
  },
  MutationTranslateMessageSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationTranslateMessageSuccess>>, Record<string, never>>
  },
  MutationUnlinkStripeAccountSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationUnlinkStripeAccountSuccess>>, Record<string, never>>
  },
  MutationUnsubscribeFromSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationUnsubscribeFromSuccess>>, Record<string, never>>
  },
  MutationUpdateCurrentPublicationSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationUpdateCurrentPublicationSuccess>>, Record<string, never>>
  },
  MutationUpdateCurrentUserSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationUpdateCurrentUserSuccess>>, Record<string, never>>
  },
  MutationUpdateNoteSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationUpdateNoteSuccess>>, Record<string, never>>
  },
  MutationUpdateOptOutFeaturedPostsSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationUpdateOptOutFeaturedPostsSuccess>>, Record<string, never>>
  },
  MutationUpdatePostSettingsSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationUpdatePostSettingsSuccess>>, Record<string, never>>
  },
  MutationUpdatePostTranslationsSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationUpdatePostTranslationsSuccess>>, Record<string, never>>
  },
  MutationUpdateReactionEmojisSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationUpdateReactionEmojisSuccess>>, Record<string, never>>
  },
  MutationUpdateWelcomeEmailSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationUpdateWelcomeEmailSuccess>>, Record<string, never>>
  },
  MutationUpsertLeadMagnetFormSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationUpsertLeadMagnetFormSuccess>>, Record<string, never>>
  },
  MutationUpsertPublicationSuccess?: {
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<MutationUpsertPublicationSuccess>>, Record<string, never>>
  },
  NotFoundError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<NotFoundError>>, Record<string, never>>
  },
  Note?: {
    content?: GraphCacheUpdateResolver<Maybe<WithTypename<Note>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Note>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Note>>, Record<string, never>>,
    posts?: GraphCacheUpdateResolver<Maybe<WithTypename<Note>>, Record<string, never>>,
    suggestedTags?: GraphCacheUpdateResolver<Maybe<WithTypename<Note>>, Record<string, never>>,
    tags?: GraphCacheUpdateResolver<Maybe<WithTypename<Note>>, Record<string, never>>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<Note>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Note>>, Record<string, never>>
  },
  OEmbedData?: {
    embedHeight?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedData>>, Record<string, never>>,
    embedHtml?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedData>>, Record<string, never>>,
    embedUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedData>>, Record<string, never>>,
    embedWidth?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedData>>, Record<string, never>>,
    providerName?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedData>>, Record<string, never>>,
    thumbnailHeight?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedData>>, Record<string, never>>,
    thumbnailUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedData>>, Record<string, never>>,
    thumbnailWidth?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedData>>, Record<string, never>>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedData>>, Record<string, never>>
  },
  OEmbedMetadata?: {
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedMetadata>>, Record<string, never>>,
    faviconUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedMetadata>>, Record<string, never>>,
    imageUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedMetadata>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedMetadata>>, Record<string, never>>
  },
  OEmbedResult?: {
    metadata?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedResult>>, Record<string, never>>,
    oembed?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedResult>>, Record<string, never>>,
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<OEmbedResult>>, Record<string, never>>
  },
  OnboardingTask?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<OnboardingTask>>, Record<string, never>>,
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<OnboardingTask>>, Record<string, never>>
  },
  PageInfo?: {
    endCursor?: GraphCacheUpdateResolver<Maybe<WithTypename<PageInfo>>, Record<string, never>>,
    hasNextPage?: GraphCacheUpdateResolver<Maybe<WithTypename<PageInfo>>, Record<string, never>>,
    hasPreviousPage?: GraphCacheUpdateResolver<Maybe<WithTypename<PageInfo>>, Record<string, never>>,
    startCursor?: GraphCacheUpdateResolver<Maybe<WithTypename<PageInfo>>, Record<string, never>>
  },
  Post?: {
    archivedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    availableLocales?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    canonicalUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    commentsEnabled?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    currentVersion?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, PostCurrentVersionArgs>,
    currentVersions?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    firstPublishedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    form?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    formId?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    humanContent?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    mainLocale?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    metaDescription?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    metaTitle?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    pinnedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    private?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    publication?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    publishedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    publishedVersion?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, PostPublishedVersionArgs>,
    publishedVersions?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    reactions?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    relatedNotes?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    sentAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    spamScore?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    stat?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    subscriberCount?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    suggestedTags?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    tags?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    tiers?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, PostUrlArgs>,
    usedProofreaderAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, Record<string, never>>,
    versions?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, PostVersionsArgs>
  },
  PostHighlight?: {
    content?: GraphCacheUpdateResolver<Maybe<WithTypename<PostHighlight>>, Record<string, never>>,
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<PostHighlight>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<PostHighlight>>, Record<string, never>>
  },
  PostSearch?: {
    highlight?: GraphCacheUpdateResolver<Maybe<WithTypename<PostSearch>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PostSearch>>, Record<string, never>>,
    post?: GraphCacheUpdateResolver<Maybe<WithTypename<PostSearch>>, Record<string, never>>,
    rank?: GraphCacheUpdateResolver<Maybe<WithTypename<PostSearch>>, Record<string, never>>
  },
  PostStat?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PostStat>>, Record<string, never>>,
    openRatePercent?: GraphCacheUpdateResolver<Maybe<WithTypename<PostStat>>, Record<string, never>>,
    recentViews?: GraphCacheUpdateResolver<Maybe<WithTypename<PostStat>>, Record<string, never>>
  },
  PostStatsItem?: {
    amount?: GraphCacheUpdateResolver<Maybe<WithTypename<PostStatsItem>>, Record<string, never>>,
    day?: GraphCacheUpdateResolver<Maybe<WithTypename<PostStatsItem>>, Record<string, never>>
  },
  PostVersion?: {
    content?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    imageHeaderUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    locale?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    metaDescription?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    metaTitle?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    postId?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    published?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    sent?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    socialImageUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    socialImageUrls?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    translated?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    translatedContent?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    translatedDescription?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    translatedTitle?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersion>>, Record<string, never>>
  },
  PostVersionsConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersionsConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersionsConnection>>, Record<string, never>>
  },
  PostVersionsConnectionEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersionsConnectionEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<PostVersionsConnectionEdge>>, Record<string, never>>
  },
  ProofreadResult?: {
    text?: GraphCacheUpdateResolver<Maybe<WithTypename<ProofreadResult>>, Record<string, never>>
  },
  Publication?: {
    additionalLanguages?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    author?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    blogFooter?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    blogHeader?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    channelStats?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, PublicationChannelStatsArgs>,
    countryStats?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, PublicationCountryStatsArgs>,
    currentFeePercent?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    dailyViews?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    enableMonetization?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    faviconUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    feeLevels?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    leadMagnetForms?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    locale?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    logoUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    nameChangeCooldownDays?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    openRatesStats?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    optOutFeaturedPosts?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    paidSubscribersCount?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    publisherId?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    reactionEmojis?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    referrerStats?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, PublicationReferrerStatsArgs>,
    stripe?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    sub?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    subscriberStats?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, PublicationSubscriberStatsArgs>,
    subscribers?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, PublicationSubscribersArgs>,
    subscribersCount?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    subscriptionTiers?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    viewStats?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    welcomeEmailContent?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    welcomeEmailSubject?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    welcomeImageUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>,
    wordmarkUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Publication>>, Record<string, never>>
  },
  PublicationExport?: {
    completedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationExport>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationExport>>, Record<string, never>>,
    error?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationExport>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationExport>>, Record<string, never>>,
    numPosts?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationExport>>, Record<string, never>>,
    numSubscribers?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationExport>>, Record<string, never>>,
    publicationId?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationExport>>, Record<string, never>>
  },
  PublicationOpenRatesStats?: {
    currentMonthEmailsSent?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationOpenRatesStats>>, Record<string, never>>,
    currentMonthOpenRatePercent?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationOpenRatesStats>>, Record<string, never>>,
    previousMonthEmailsSent?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationOpenRatesStats>>, Record<string, never>>,
    previousMonthOpenRatePercent?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationOpenRatesStats>>, Record<string, never>>
  },
  PublicationSubscribersConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationSubscribersConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationSubscribersConnection>>, Record<string, never>>
  },
  PublicationSubscribersConnectionEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationSubscribersConnectionEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationSubscribersConnectionEdge>>, Record<string, never>>
  },
  PublicationViewStats?: {
    change?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationViewStats>>, Record<string, never>>,
    currentPeriodViews?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationViewStats>>, Record<string, never>>,
    percentChange?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationViewStats>>, Record<string, never>>,
    previousPeriodViews?: GraphCacheUpdateResolver<Maybe<WithTypename<PublicationViewStats>>, Record<string, never>>
  },
  PublishedPost?: {
    comments?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedPost>>, Record<string, never>>,
    commentsEnabled?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedPost>>, Record<string, never>>,
    content?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedPost>>, Record<string, never>>,
    contentAccess?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedPost>>, Record<string, never>>,
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedPost>>, Record<string, never>>,
    featuredAt?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedPost>>, Record<string, never>>,
    firstPublishedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedPost>>, Record<string, never>>,
    humanContent?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedPost>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedPost>>, Record<string, never>>,
    imageUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedPost>>, Record<string, never>>,
    publication?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedPost>>, Record<string, never>>,
    reactions?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedPost>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedPost>>, Record<string, never>>,
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedPost>>, Record<string, never>>
  },
  QueryLatestPostNotesConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryLatestPostNotesConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryLatestPostNotesConnection>>, Record<string, never>>
  },
  QueryLatestPostNotesConnectionEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryLatestPostNotesConnectionEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryLatestPostNotesConnectionEdge>>, Record<string, never>>
  },
  QueryPostsConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryPostsConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryPostsConnection>>, Record<string, never>>
  },
  QueryPostsConnectionEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryPostsConnectionEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryPostsConnectionEdge>>, Record<string, never>>
  },
  QueryPublishedPostsConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryPublishedPostsConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryPublishedPostsConnection>>, Record<string, never>>
  },
  QueryPublishedPostsConnectionEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryPublishedPostsConnectionEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryPublishedPostsConnectionEdge>>, Record<string, never>>
  },
  QuerySubsConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<QuerySubsConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<QuerySubsConnection>>, Record<string, never>>
  },
  QuerySubsConnectionEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<QuerySubsConnectionEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<QuerySubsConnectionEdge>>, Record<string, never>>
  },
  ReactionSummary?: {
    count?: GraphCacheUpdateResolver<Maybe<WithTypename<ReactionSummary>>, Record<string, never>>,
    emoji?: GraphCacheUpdateResolver<Maybe<WithTypename<ReactionSummary>>, Record<string, never>>,
    reacted?: GraphCacheUpdateResolver<Maybe<WithTypename<ReactionSummary>>, Record<string, never>>
  },
  SocialImageUrls?: {
    landscape?: GraphCacheUpdateResolver<Maybe<WithTypename<SocialImageUrls>>, Record<string, never>>,
    portrait?: GraphCacheUpdateResolver<Maybe<WithTypename<SocialImageUrls>>, Record<string, never>>,
    square?: GraphCacheUpdateResolver<Maybe<WithTypename<SocialImageUrls>>, Record<string, never>>,
    story?: GraphCacheUpdateResolver<Maybe<WithTypename<SocialImageUrls>>, Record<string, never>>
  },
  Stripe?: {
    accountId?: GraphCacheUpdateResolver<Maybe<WithTypename<Stripe>>, Record<string, never>>,
    businessName?: GraphCacheUpdateResolver<Maybe<WithTypename<Stripe>>, Record<string, never>>,
    companyName?: GraphCacheUpdateResolver<Maybe<WithTypename<Stripe>>, Record<string, never>>,
    dashboardUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Stripe>>, Record<string, never>>,
    iconUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Stripe>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Stripe>>, Record<string, never>>,
    setupComplete?: GraphCacheUpdateResolver<Maybe<WithTypename<Stripe>>, Record<string, never>>
  },
  StripePrice?: {
    currency?: GraphCacheUpdateResolver<Maybe<WithTypename<StripePrice>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<StripePrice>>, Record<string, never>>,
    interval?: GraphCacheUpdateResolver<Maybe<WithTypename<StripePrice>>, Record<string, never>>,
    unitAmount?: GraphCacheUpdateResolver<Maybe<WithTypename<StripePrice>>, Record<string, never>>
  },
  Sub?: {
    billingInterval?: GraphCacheUpdateResolver<Maybe<WithTypename<Sub>>, Record<string, never>>,
    currentPeriodEnd?: GraphCacheUpdateResolver<Maybe<WithTypename<Sub>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Sub>>, Record<string, never>>,
    post?: GraphCacheUpdateResolver<Maybe<WithTypename<Sub>>, Record<string, never>>,
    publication?: GraphCacheUpdateResolver<Maybe<WithTypename<Sub>>, Record<string, never>>,
    stripeSubscriptionId?: GraphCacheUpdateResolver<Maybe<WithTypename<Sub>>, Record<string, never>>,
    subscribedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Sub>>, Record<string, never>>,
    tier?: GraphCacheUpdateResolver<Maybe<WithTypename<Sub>>, Record<string, never>>
  },
  Subscriber?: {
    email?: GraphCacheUpdateResolver<Maybe<WithTypename<Subscriber>>, Record<string, never>>,
    form?: GraphCacheUpdateResolver<Maybe<WithTypename<Subscriber>>, Record<string, never>>,
    formName?: GraphCacheUpdateResolver<Maybe<WithTypename<Subscriber>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Subscriber>>, Record<string, never>>,
    searchResult?: GraphCacheUpdateResolver<Maybe<WithTypename<Subscriber>>, Record<string, never>>,
    subscribedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Subscriber>>, Record<string, never>>,
    tier?: GraphCacheUpdateResolver<Maybe<WithTypename<Subscriber>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<Subscriber>>, Record<string, never>>
  },
  SubscriberHighlight?: {
    email?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriberHighlight>>, Record<string, never>>
  },
  SubscriberSearchResult?: {
    highlight?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriberSearchResult>>, Record<string, never>>,
    rank?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriberSearchResult>>, Record<string, never>>
  },
  SubscriptionTier?: {
    annualPriceCents?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriptionTier>>, Record<string, never>>,
    canPurchase?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriptionTier>>, Record<string, never>>,
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriptionTier>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriptionTier>>, Record<string, never>>,
    monthlyPriceCents?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriptionTier>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriptionTier>>, Record<string, never>>,
    publication?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriptionTier>>, Record<string, never>>,
    stripeAnnualPriceId?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriptionTier>>, Record<string, never>>,
    stripeMonthlyPriceId?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriptionTier>>, Record<string, never>>,
    stripeProductId?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriptionTier>>, Record<string, never>>,
    subscriberCount?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriptionTier>>, Record<string, never>>
  },
  TableStatsItem?: {
    label?: GraphCacheUpdateResolver<Maybe<WithTypename<TableStatsItem>>, Record<string, never>>,
    pageviews?: GraphCacheUpdateResolver<Maybe<WithTypename<TableStatsItem>>, Record<string, never>>,
    visitors?: GraphCacheUpdateResolver<Maybe<WithTypename<TableStatsItem>>, Record<string, never>>
  },
  Tags?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Tags>>, Record<string, never>>,
    tags?: GraphCacheUpdateResolver<Maybe<WithTypename<Tags>>, Record<string, never>>
  },
  Thread?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Thread>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Thread>>, Record<string, never>>,
    lastMessage?: GraphCacheUpdateResolver<Maybe<WithTypename<Thread>>, Record<string, never>>,
    messages?: GraphCacheUpdateResolver<Maybe<WithTypename<Thread>>, Record<string, never>>,
    participantCount?: GraphCacheUpdateResolver<Maybe<WithTypename<Thread>>, Record<string, never>>,
    participants?: GraphCacheUpdateResolver<Maybe<WithTypename<Thread>>, Record<string, never>>,
    post?: GraphCacheUpdateResolver<Maybe<WithTypename<Thread>>, Record<string, never>>,
    postId?: GraphCacheUpdateResolver<Maybe<WithTypename<Thread>>, Record<string, never>>,
    private?: GraphCacheUpdateResolver<Maybe<WithTypename<Thread>>, Record<string, never>>,
    subject?: GraphCacheUpdateResolver<Maybe<WithTypename<Thread>>, Record<string, never>>,
    unreadCount?: GraphCacheUpdateResolver<Maybe<WithTypename<Thread>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Thread>>, Record<string, never>>
  },
  TranslateFieldsResult?: {
    results?: GraphCacheUpdateResolver<Maybe<WithTypename<TranslateFieldsResult>>, Record<string, never>>
  },
  TranslateMessageResult?: {
    renderedContent?: GraphCacheUpdateResolver<Maybe<WithTypename<TranslateMessageResult>>, Record<string, never>>,
    translatedContent?: GraphCacheUpdateResolver<Maybe<WithTypename<TranslateMessageResult>>, Record<string, never>>
  },
  UnauthorizedError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<UnauthorizedError>>, Record<string, never>>
  },
  UnlinkStripeAccountResult?: {
    publication?: GraphCacheUpdateResolver<Maybe<WithTypename<UnlinkStripeAccountResult>>, Record<string, never>>
  },
  User?: {
    authorName?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    bio?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    email?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    followsYou?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    isMe?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    profileImage?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    publication?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    publicationUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    socialBandcamp?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    socialBluesky?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    socialBooks?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    socialFacebook?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    socialInstagram?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    socialLinkedin?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    socialSoundcloud?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    socialTiktok?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    socialWebsite?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    socialX?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    socialYoutube?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    username?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>
  },
  ValidationError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<ValidationError>>, Record<string, never>>
  },
};

export type GraphCacheConfig = Parameters<typeof cacheExchange>[0] & {
  updates?: GraphCacheUpdaters,
  keys?: GraphCacheKeysConfig,
  optimistic?: GraphCacheOptimisticUpdaters,
  resolvers?: GraphCacheResolvers,
};